import { Input, Output, EventEmitter, NgModule, Injectable, Component, ElementRef, Renderer2, forwardRef, ContentChild, Inject, ViewChild, HostListener, ComponentFactoryResolver, ApplicationRef, TemplateRef, Pipe, Directive, NgZone, ContentChildren, ViewContainerRef, Renderer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormControl, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateStore } from '@ngx-translate/core/src/translate.store';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs/Rx';
import { RequestOptions, ResponseContentType, Headers, Http } from '@angular/http';
import { DomSanitizer, DOCUMENT } from '@angular/platform-browser';
import { DynamicComponentModule } from 'ng-dynamic';
import { times, find, remove, isEmpty, map, join, truncate, concat, filter, orderBy, get, forEach, replace, isArray } from 'lodash';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core/src/translate.service';
import { trigger, transition, style, animate } from '@angular/animations';

var DefaultControlValueAccessor = (function () {
    function DefaultControlValueAccessor() {
        this.disabled = false;
        this.onValueChange = new EventEmitter();
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    Object.defineProperty(DefaultControlValueAccessor.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
            this.onValueChange.emit(this.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultControlValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultControlValueAccessor.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultControlValueAccessor.prototype.writeValue = function (value) {
        this._value = value;
    };
    /**
     * @param {?} disabled
     * @return {?}
     */
    DefaultControlValueAccessor.prototype.setDisabledState = function (disabled) {
        this.disabled = disabled;
    };
    DefaultControlValueAccessor.propDecorators = {
        '_value': [{ type: Input, args: ['value',] },],
        'disabled': [{ type: Input },],
        'onValueChange': [{ type: Output },],
    };
    return DefaultControlValueAccessor;
}());

var AsiNgToolsBaseModule = (function () {
    function AsiNgToolsBaseModule() {
    }
    /**
     * @return {?}
     */
    AsiNgToolsBaseModule.forRoot = function () {
        return {
            ngModule: AsiNgToolsBaseModule,
            providers: [TranslateStore]
        };
    };
    AsiNgToolsBaseModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CommonModule,
                        RouterModule],
                    exports: [TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CommonModule,
                        RouterModule],
                    entryComponents: [],
                    providers: [TranslateStore]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiNgToolsBaseModule.ctorParameters = function () { return []; };
    return AsiNgToolsBaseModule;
}());

/**
 * Service de gestion de fichier
 */
var AsiFileService = (function () {
    /**
     * @param {?} http
     * @param {?} sanitizer
     */
    function AsiFileService(http, sanitizer) {
        this.http = http;
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} file
     * @param {?=} sanitize
     * @return {?}
     */
    AsiFileService.prototype.fileToBase64 = function (file, sanitize) {
        return this.toBase64(file, sanitize);
    };
    /**
     * @param {?} blob
     * @param {?=} sanitize
     * @return {?}
     */
    AsiFileService.prototype.blobToBase64 = function (blob, sanitize) {
        return this.toBase64(blob, sanitize);
    };
    /**
     * @param {?} data
     * @param {?=} sanitize
     * @return {?}
     */
    AsiFileService.prototype.toBase64 = function (data, sanitize) {
        var _this = this;
        return Observable.create(function (observer) {
            var /** @type {?} */ reader = new FileReader();
            reader.onloadend = function () {
                var /** @type {?} */ content = reader.result;
                if (sanitize) {
                    content = _this.sanitizer.bypassSecurityTrustUrl(content);
                }
                observer.next(content);
                observer.complete();
            };
            reader.readAsDataURL(data);
        });
    };
    /**
     * Download the blob file with the specified name
     * @param {?} fileAsBlob the file to download as a Blob
     * @param {?} fileName the name to give to the downloaded file
     * @return {?}
     */
    AsiFileService.prototype.saveToFile = function (fileAsBlob, fileName) {
        // If no name is provided, we use the original name if available, or a default name
        if (!fileName) {
            if (!fileAsBlob.name) {
                fileName = "tmpFile";
            }
            else {
                fileName = fileAsBlob.name;
            }
        }
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(fileAsBlob, fileName);
        }
        else {
            var /** @type {?} */ url = window.URL.createObjectURL(fileAsBlob);
            var /** @type {?} */ anchor = document.createElement("a");
            anchor.download = fileName;
            anchor.target = '_blank';
            anchor.href = url;
            anchor.dispatchEvent(new MouseEvent("click"));
        }
    };
    /**
     * Transform a Blob into a File adding a file name and a last modified date
     * @param {?} response The blob response
     * @return {?}
     */
    AsiFileService.prototype.getFileFromBlobResponse = function (response) {
        var /** @type {?} */ blob = response.blob();
        // May be null if the server doesn't explicitly add the content-disposition in the headers
        var /** @type {?} */ originalFileName = response.headers.get("content-disposition");
        if (originalFileName) {
            originalFileName = originalFileName.substring(originalFileName.lastIndexOf('filename=') + 9);
        }
        // The two attributes missing to a Blob to be a File
        blob.name = originalFileName;
        blob.lastModifiedDate = new Date();
        return (blob);
    };
    /**
     * @param {?} file
     * @return {?}
     */
    AsiFileService.prototype.getFileUrl = function (file) {
        var /** @type {?} */ url = URL.createObjectURL(file);
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    /**
     * @param {?} fileUrl
     * @return {?}
     */
    AsiFileService.prototype.getFileAsText = function (fileUrl) {
        return this.http.get(fileUrl).map(function (res) { return res.text(); });
    };
    /**
     * @param {?} fileUrl
     * @return {?}
     */
    AsiFileService.prototype.getFileAsBlob = function (fileUrl) {
        var _this = this;
        var /** @type {?} */ requestOptions = new RequestOptions();
        requestOptions.responseType = ResponseContentType.Blob;
        return this.http.get(fileUrl, requestOptions).map(function (response) {
            return _this.getFileFromBlobResponse(response);
        });
    };
    /**
     * @param {?} fileUrl
     * @param {?} body
     * @return {?}
     */
    AsiFileService.prototype.getFileAsBlobFromPostRequest = function (fileUrl, body) {
        var _this = this;
        var /** @type {?} */ requestOptions = new RequestOptions();
        requestOptions.responseType = ResponseContentType.Blob;
        return this.http.post(fileUrl, body, requestOptions).map(function (response) {
            return _this.getFileFromBlobResponse(response);
        });
    };
    /**
     * Download the file at the given url
     * @param {?} fileUrl The url of the downloadable file
     * @param {?=} fileName [Optional] The new name of the downloaded file
     * @return {?}
     */
    AsiFileService.prototype.downloadFile = function (fileUrl, fileName) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.getFileAsBlob(fileUrl).subscribe(function (fileAsBlob) {
                _this.saveToFile(fileAsBlob, fileName);
                observer.next();
                observer.complete();
            });
        });
    };
    /**
     * Download the file at the given url from a POST request
     * @param {?} fileUrl The url of the downloadable file
     * @param {?} body the POST request body
     * @param {?=} fileName [Optional] The new name of the downloaded file
     * @return {?}
     */
    AsiFileService.prototype.downloadFileFromPostRequest = function (fileUrl, body, fileName) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.getFileAsBlobFromPostRequest(fileUrl, body).subscribe(function (fileAsBlob) {
                _this.saveToFile(fileAsBlob, fileName);
                observer.next();
                observer.complete();
            });
        });
    };
    /**
     * @param {?} fileUrl
     * @return {?}
     */
    AsiFileService.prototype.getBlobImage = function (fileUrl) {
        var /** @type {?} */ requestOptions = new RequestOptions();
        requestOptions.responseType = ResponseContentType.Blob;
        return this.http.get(fileUrl, requestOptions).map(function (response) { return response.blob(); });
    };
    /**
     * @param {?} url
     * @param {?} file
     * @return {?}
     */
    AsiFileService.prototype.uploadFile = function (url, file) {
        var /** @type {?} */ formData = new FormData();
        formData.append('file', file, file.name);
        var /** @type {?} */ headers = new Headers();
        var /** @type {?} */ options = new RequestOptions({ headers: headers });
        return this.http.post(url, formData, options);
    };
    AsiFileService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiFileService.ctorParameters = function () { return [
        { type: Http, },
        { type: DomSanitizer, },
    ]; };
    return AsiFileService;
}());

var AsiBindAndCompileHtml = (function () {
    /**
     * @param {?} fileService
     */
    function AsiBindAndCompileHtml(fileService) {
        this.fileService = fileService;
    }
    /**
     * @return {?}
     */
    AsiBindAndCompileHtml.prototype.ngOnInit = function () {
        var _this = this;
        if (this.fromUrl != null) {
            this.fileService.getFileAsText(this.fromUrl).subscribe(function (result) {
                _this.value = result;
            });
        }
    };
    AsiBindAndCompileHtml.decorators = [
        { type: Component, args: [{
                    selector: 'asi-bind-and-compile-html',
                    template: '<div *dynamicComponent="value; context : context;"><div>',
                    host: { 'class': 'asi-component asi-bind-and-compile-html' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiBindAndCompileHtml.ctorParameters = function () { return [
        { type: AsiFileService, },
    ]; };
    AsiBindAndCompileHtml.propDecorators = {
        'value': [{ type: Input },],
        'fromUrl': [{ type: Input },],
        'context': [{ type: Input },],
    };
    return AsiBindAndCompileHtml;
}());

var AsiBindAndCompileHtmlModule = (function () {
    function AsiBindAndCompileHtmlModule() {
    }
    /**
     * @return {?}
     */
    AsiBindAndCompileHtmlModule.forRoot = function () {
        return {
            ngModule: AsiBindAndCompileHtmlModule,
            providers: [AsiFileService]
        };
    };
    AsiBindAndCompileHtmlModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiBindAndCompileHtml],
                    imports: [AsiNgToolsBaseModule.forRoot(), DynamicComponentModule],
                    exports: [AsiNgToolsBaseModule, AsiBindAndCompileHtml, DynamicComponentModule],
                    entryComponents: [],
                    providers: [AsiFileService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiBindAndCompileHtmlModule.ctorParameters = function () { return []; };
    return AsiBindAndCompileHtmlModule;
}());

var AsiButtonComponent = (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiButtonComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.design = 'flat';
        this.type = 'button';
        this.disabled = false;
    }
    /**
     * @return {?}
     */
    AsiButtonComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "button-" + this.design);
    };
    AsiButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-button',
                    template: "<button [attr.type]=\"type\" [disabled]=\"disabled\"> <ng-content></ng-content> </button>",
                    host: { 'class': 'asi-component asi-button' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiButtonComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiButtonComponent.propDecorators = {
        'design': [{ type: Input },],
        'type': [{ type: Input },],
        'disabled': [{ type: Input },],
    };
    return AsiButtonComponent;
}());

var AsiLinkButtonComponent = (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiLinkButtonComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.design = 'flat';
        this.href = "";
        this.target = "_self";
        this.disabled = false;
    }
    /**
     * @return {?}
     */
    AsiLinkButtonComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "link-button-" + this.design);
    };
    AsiLinkButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-link-button',
                    template: "<a [attr.disabled]=\"disabled ? true : null\" [attr.href]=\"href\" [attr.target]=\"target\"> <ng-content></ng-content> </a>",
                    host: { 'class': 'asi-component asi-link-button' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiLinkButtonComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiLinkButtonComponent.propDecorators = {
        'design': [{ type: Input },],
        'href': [{ type: Input },],
        'target': [{ type: Input },],
        'disabled': [{ type: Input },],
    };
    return AsiLinkButtonComponent;
}());

var AsiButtonModule = (function () {
    function AsiButtonModule() {
    }
    /**
     * @return {?}
     */
    AsiButtonModule.forRoot = function () {
        return {
            ngModule: AsiButtonModule,
            providers: []
        };
    };
    AsiButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiButtonComponent, AsiLinkButtonComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiButtonComponent, AsiLinkButtonComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiButtonModule.ctorParameters = function () { return []; };
    return AsiButtonModule;
}());

var /** @type {?} */ months_fr = [
    { num: 1, libelle: "Janvier" },
    { num: 2, libelle: "Février" },
    { num: 3, libelle: "Mars" },
    { num: 4, libelle: "Avril" },
    { num: 5, libelle: "Mai" },
    { num: 6, libelle: "Juin" },
    { num: 7, libelle: "Juillet" },
    { num: 8, libelle: "Août" },
    { num: 9, libelle: "Septembre" },
    { num: 10, libelle: "Octobre" },
    { num: 11, libelle: "Novembre" },
    { num: 12, libelle: "Décembre" },
];
var /** @type {?} */ months_en = [
    { num: 1, libelle: "January" },
    { num: 2, libelle: "February" },
    { num: 3, libelle: "March" },
    { num: 4, libelle: "April" },
    { num: 5, libelle: "May" },
    { num: 6, libelle: "June" },
    { num: 7, libelle: "July" },
    { num: 8, libelle: "August" },
    { num: 9, libelle: "September" },
    { num: 10, libelle: "October" },
    { num: 11, libelle: "November" },
    { num: 12, libelle: "Decemder" }
];

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiDmyPickerComponent = (function (_super) {
    __extends(AsiDmyPickerComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiDmyPickerComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.dayHidden = false;
        _this.days = [];
        _this.months = [];
        _this.years = [];
        if (_this.isFr()) {
            _this.months = months_fr;
            _this.dayLabel = "Jour";
            _this.monthLabel = "Mois";
            _this.yearLabel = "Annee";
        }
        else {
            _this.months = months_en;
            _this.dayLabel = "Day";
            _this.monthLabel = "Month";
            _this.yearLabel = "Year";
        }
        _this.initDays();
        _this.initYears();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.isFr = function () {
        return navigator.language == "fr" || navigator.language == "fr-FR";
    };
    /**
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.initDays = function () {
        var _this = this;
        times(31, function (time) {
            _this.days.push(time + 1);
        });
    };
    /**
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.initYears = function () {
        var /** @type {?} */ results = new Array();
        var /** @type {?} */ currentYear = new Date().getFullYear();
        for (var /** @type {?} */ year = currentYear; year >= 1900; year--) {
            results.push(year);
        }
        this.years = results;
    };
    /**
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @param {?} month
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.onMonthChange = function (month) {
        this.value = { day: this.day, month: month != null ? month.num : null, year: this.year };
    };
    /**
     * @param {?} year
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.onYearChange = function (year) {
        this.value = { day: this.day, month: this.month != null ? this.month.num : null, year: year };
    };
    /**
     * @param {?} day
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.onDayChange = function (day) {
        this.value = { day: day, month: this.month != null ? this.month.num : null, year: this.year };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.writeValue = function (value) {
        if (value != null) {
            this.day = value.day;
            this.month = this.getMontFromNum(value.month);
            this.year = value.year;
        }
        else {
            this.day = null;
            this.month = null;
            this.year = null;
        }
        this._value = { day: this.day, month: this.month, year: this.year };
    };
    /**
     * @param {?} monthNum
     * @return {?}
     */
    AsiDmyPickerComponent.prototype.getMontFromNum = function (monthNum) {
        if (monthNum == null) {
            return null;
        }
        return find(this.months, function (month) {
            return month.num == monthNum;
        });
    };
    AsiDmyPickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-dmypicker',
                    template: "<label class=\"input-label\" [translate]=\"label\"></label> <div class=\"asi-dmypicker-container\"> <asi-select class=\"asi-dmy-days\" [disabled]=\"disabled\" [withEmptyValue]=\"true\" [hidden]=\"dayHidden\" [datas]=\"days\"  [(ngModel)]=\"day\" (ngModelChange)=\"onDayChange($event)\"> <ng-template #empty>{{dayLabel}}</ng-template> <ng-template #selected let-data=\"data\">{{data}}</ng-template> <ng-template #option let-data=\"data\">{{data}}</ng-template> </asi-select> <asi-select class=\"asi-dmy-months\" [disabled]=\"disabled\" [withEmptyValue]=\"true\" [datas]=\"months\" [(ngModel)]=\"month\"  (ngModelChange)=\"onMonthChange($event)\"> <ng-template #empty>{{monthLabel}}</ng-template> <ng-template #selected let-data=\"data\">{{data.num + \" - \" + data.libelle}}</ng-template> <ng-template #option let-data=\"data\">{{data.num + \" - \" + data.libelle}}</ng-template> </asi-select> <asi-select class=\"asi-dmy-years\" [disabled]=\"disabled\" [withEmptyValue]=\"true\" [datas]=\"years\" [(ngModel)]=\"year\" (ngModelChange)=\"onYearChange($event)\"> <ng-template #empty>{{yearLabel}}</ng-template> <ng-template #selected let-data=\"data\">{{data}}</ng-template> <ng-template #option let-data=\"data\">{{data}}</ng-template> </asi-select> </div>",
                    host: { 'class': 'asi-component asi-dmypicker' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiDmyPickerComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDmyPickerComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiDmyPickerComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'dayHidden': [{ type: Input },],
    };
    return AsiDmyPickerComponent;
}(DefaultControlValueAccessor));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiCheckboxComponent = (function (_super) {
    __extends$1(AsiCheckboxComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiCheckboxComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.type = "checkbox";
        return _this;
    }
    /**
     * @return {?}
     */
    AsiCheckboxComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiCheckboxComponent.prototype.toggleCheck = function () {
        this.value = !this.value;
    };
    AsiCheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-checkbox',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <button type=\"button\" [disabled]=\"disabled\" (click)=\"toggleCheck()\" class=\"checkbox asi-focus-error\" [ngClass]=\"{ 'checked': value, 'radio' : type == 'radio' }\"> <div><span class=\"checkbox-button\"></span></div> </button>",
                    host: { 'class': 'asi-component asi-checkbox' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiCheckboxComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCheckboxComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiCheckboxComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'type': [{ type: Input },],
    };
    return AsiCheckboxComponent;
}(DefaultControlValueAccessor));

var AsiCheckBoxModule = (function () {
    function AsiCheckBoxModule() {
    }
    /**
     * @return {?}
     */
    AsiCheckBoxModule.forRoot = function () {
        return {
            ngModule: AsiCheckBoxModule,
            providers: []
        };
    };
    AsiCheckBoxModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiCheckboxComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiCheckboxComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCheckBoxModule.ctorParameters = function () { return []; };
    return AsiCheckBoxModule;
}());

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Composant permettant de gerer un champ select
[label] : libelle de select
[datas] : l'ensemble des valeurs possibles du select
[(ngModel)] : le model
Exemple d'utilisation :
 <div class="select">
   <asi-select [label]="'Referentiel'" [datas]="datas" [withEmptyValue]="'true'" formControlName="myModel">
     <ng-template #empty>-- Please select a value --</ng-template>
     <ng-template #option let-data="data">{{data?.code}}  - {{data?.libelle}}</ng-template>
   </asi-select>
   <error-messages [for]="myForm.get('myModel')">
     <message [error]="'required'" [value]="'ERRORS.required'" [onSubmit]="'true'"></message>
   </error-messages>
 </div>
 */
var AsiSelectComponent = (function (_super) {
    __extends$2(AsiSelectComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiSelectComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.disabled = false;
        _this.labelPosition = "top";
        _this.multiple = false;
        _this.withEmptyValue = false;
        _this.open = false;
        _this.allChecked = false;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.onDropdownClose = function () {
        this.open = false;
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.isOpened = function () {
        return this.open;
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.ngOnChanges = function () {
        this.initData();
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.initData = function () {
        var _this = this;
        this.selectDatas = [];
        if (this.withEmptyValue) {
            this.selectDatas.push(null);
        }
        this.datas.forEach(function (data) {
            var /** @type {?} */ proxyData = {
                selected: false,
                value: data
            };
            _this.selectDatas.push(proxyData);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiSelectComponent.prototype.checkAll = function (value) {
        var _this = this;
        this.allChecked = value;
        this.selectDatas.forEach(function (data) {
            if (data != null && (value != data.selected)) {
                _this.selectValue(null, data);
            }
        });
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.updateAllChecked = function () {
        this.allChecked = find(this.selectDatas, function (data) {
            return data != null ? !data.selected : false;
        }) == null;
    };
    /**
     * @param {?} event
     * @param {?} data
     * @return {?}
     */
    AsiSelectComponent.prototype.selectValue = function (event, data) {
        var _this = this;
        console.log("SELECT");
        if (data == null) {
            this.onModelChange(null);
            this.open = false;
            return;
        }
        var /** @type {?} */ realValue = data.value;
        if (this.multiple) {
            if (event != null) {
                event.stopPropagation();
            }
            if (this._value == null) {
                this._value = [];
            }
            var /** @type {?} */ removed = remove(this._value, function (value) {
                if (value != null) {
                    if (_this.trackBy != null) {
                        return value[_this.trackBy] == realValue[_this.trackBy];
                    }
                    else {
                        return value == realValue;
                    }
                }
                return false;
            });
            if (isEmpty(removed)) {
                this.value.push(realValue);
                data.selected = true;
            }
            else {
                data.selected = false;
            }
            if (isEmpty(this._value)) {
                this.value = null;
            }
            if (event != null) {
                this.updateAllChecked();
            }
            this.onModelChange(this._value);
        }
        else {
            this.onModelChange(realValue);
            this.open = false;
        }
    };
    /**
     * @return {?}
     */
    AsiSelectComponent.prototype.toggleSelect = function () {
        this.open = !this.open;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiSelectComponent.prototype.writeValue = function (value) {
        var _this = this;
        if (isNaN(value) && isEmpty(value)) {
            this._value = null;
        }
        else {
            this._value = value;
        }
        if (this.multiple) {
            if (this._value != null) {
                this.selectDatas.forEach(function (data) {
                    if (data != null) {
                        data.selected = find(_this.value, function (value) {
                            if (value != null) {
                                if (_this.trackBy != null) {
                                    return value[_this.trackBy] == data.value[_this.trackBy];
                                }
                                else {
                                    return value == data.value;
                                }
                            }
                            return false;
                        }) != null;
                    }
                });
            }
            else {
                this.selectDatas.forEach(function (data) {
                    if (data != null) {
                        data.selected = false;
                    }
                });
            }
            this.updateAllChecked();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiSelectComponent.prototype.onModelChange = function (value) {
        this.value = value;
    };
    AsiSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-select',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"asi-select-container\" aria-labelledby=\"select\"> <button type=\"button\" class=\"asi-select-header asi-focus-error\" [disabled]=\"disabled\" (click)=\"toggleSelect()\" (keyup.esc)=\"toggleSelect()\"> <span> <asi-checkbox *ngIf=\"multiple\" [disabled]=\"disabled\" [ngModel]=\"allChecked\" (onValueChange)=\"checkAll($event)\"></asi-checkbox> <div class=\"item-container\"> <span> <div class=\"item\"> <ng-template *ngIf=\"value != null\" [ngTemplateOutlet]=\"selected\" [ngOutletContext]=\"{data : value}\"></ng-template> <ng-template *ngIf=\"value == null\" [ngTemplateOutlet]=\"empty\" [ngOutletContext]=\"{data : value}\"></ng-template> </div> <div class=\"drop-icon-container\"> <span class=\"drop-icon\" [innerHtml]=\"'&#9660;'\"></span> </div> </span> </div> </span> </button> <asi-dropdown [open]=\"open\" (onClose)=\"onDropdownClose()\"> <div class=\"drop-down-select\"> <div class=\"drop-down-panel\"> <button type=\"button\" class=\"drop-down-item\" [ngClass]=\"{'empty' : data == null , 'selected' : data?.selected}\" (keyup.esc)=\"toggleSelect()\" (click)=\"selectValue($event, data)\" *ngFor=\"let data of selectDatas\"> <span class=\"option\"> <asi-checkbox *ngIf=\"multiple && data != null\" [ngModel]=\"data.selected\" (click)=\"selectValue($event, data)\"></asi-checkbox> <div class=\"item\" aria-labelledby=\"item\"> <ng-template *ngIf=\"data != null\" [ngTemplateOutlet]=\"option\" [ngOutletContext]=\"{data : data.value}\"></ng-template> </div> </span> </button> </div> </div> </asi-dropdown> </div>",
                    host: { 'class': 'asi-component asi-select' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiSelectComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiSelectComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiSelectComponent.propDecorators = {
        'label': [{ type: Input },],
        'disabled': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'datas': [{ type: Input },],
        'multiple': [{ type: Input },],
        'trackBy': [{ type: Input },],
        'withEmptyValue': [{ type: Input },],
        'option': [{ type: ContentChild, args: ["option",] },],
        'empty': [{ type: ContentChild, args: ["empty",] },],
        'selected': [{ type: ContentChild, args: ["selected",] },],
    };
    return AsiSelectComponent;
}(DefaultControlValueAccessor));

var AsiDropdownContainer = (function () {
    /**
     * @param {?} document
     * @param {?} element
     */
    function AsiDropdownContainer(document, element) {
        this.document = document;
        this.element = element;
        this.calculWidth = true;
        this.subjectContainer = new Subject();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    AsiDropdownContainer.prototype.documentClick = function (event) {
        var _this = this;
        if (!this.drop.nativeElement.contains(event.target) && this.asiDropDownService.canClose(this.index)) {
            setTimeout(function () {
                _this.subjectContainer.next(_this);
                _this.subjectContainer.complete();
            });
        }
    };
    /**
     * @return {?}
     */
    AsiDropdownContainer.prototype.close = function () {
        this.subjectContainer.next(this);
        this.subjectContainer.complete();
    };
    /**
     * @return {?}
     */
    AsiDropdownContainer.prototype.onClose = function () {
        return this.subjectContainer.asObservable();
    };
    /**
     * Move the container under htmlElement
     * @param {?} elementRef
     * @return {?}
     */
    AsiDropdownContainer.prototype.forElement = function (elementRef) {
        this.referenceElement = elementRef;
        var /** @type {?} */ rectPos = elementRef.getBoundingClientRect();
        //Get the computed class margin (from both style + css class)
        var /** @type {?} */ bodyMTop = parseInt(getComputedStyle(this.document.body).marginTop.slice(0, -2));
        var /** @type {?} */ bodyMLeft = parseInt(getComputedStyle(this.document.body).marginLeft.slice(0, -2));
        this.drop.nativeElement.style.top = rectPos.top + elementRef.offsetHeight + this.document.documentElement.scrollTop - bodyMTop + 'px';
        this.drop.nativeElement.style.left = rectPos.left + this.document.documentElement.scrollLeft - bodyMLeft + 'px';
        this.drop.nativeElement.style.width = elementRef.offsetWidth + 'px';
    };
    /**
     * @param {?} asiDrownDown
     * @return {?}
     */
    AsiDropdownContainer.prototype.show = function (asiDrownDown) {
        var _this = this;
        setTimeout(function () {
            _this.template = asiDrownDown.contentTemplate;
            var /** @type {?} */ elementRef = asiDrownDown.contentTemplate.elementRef.nativeElement.style;
            var /** @type {?} */ visibility = _this.drop.nativeElement.style.visibility;
            _this.drop.nativeElement.style.visibility = "hidden";
            setTimeout(function () {
                var /** @type {?} */ dropRight = _this.drop.nativeElement.offsetLeft + _this.drop.nativeElement.offsetWidth;
                if (dropRight > _this.document.documentElement.clientWidth) {
                    _this.drop.nativeElement.style.left = _this.drop.nativeElement.offsetLeft + _this.document.documentElement.scrollLeft - (dropRight - _this.document.documentElement.clientWidth) + 'px';
                }
                _this.drop.nativeElement.style.visibility = visibility;
            });
        });
    };
    /**
     * @param {?} service
     * @return {?}
     */
    AsiDropdownContainer.prototype.injectService = function (service) {
        this.asiDropDownService = service;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    AsiDropdownContainer.prototype.setIndex = function (index) {
        this.index = index;
        this.element.nativeElement.style.zIndex = AsiDropdownContainer.baseIndex + index;
    };
    /**
     * @param {?} calculWidth
     * @return {?}
     */
    AsiDropdownContainer.prototype.setCalculWidth = function (calculWidth) {
        if (calculWidth) {
            this.drop.nativeElement.style.width = this.referenceElement.offsetWidth + 'px';
        }
        else {
            this.drop.nativeElement.style.width = '';
        }
    };
    AsiDropdownContainer.baseIndex = 125;
    AsiDropdownContainer.decorators = [
        { type: Component, args: [{
                    selector: 'asi-dropdown-container',
                    template: "<div #drop class=\"dropdown-container\"> <ng-template [ngTemplateOutlet]=\"template\"></ng-template> </div>",
                    host: { 'class': 'asi-component asi-dropdown-container' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDropdownContainer.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
        { type: ElementRef, },
    ]; };
    AsiDropdownContainer.propDecorators = {
        'calculWidth': [{ type: Input },],
        'drop': [{ type: ViewChild, args: ['drop', { read: ElementRef },] },],
        'documentClick': [{ type: HostListener, args: ['document:mouseup', ['$event'],] },],
    };
    return AsiDropdownContainer;
}());

var AsiDropdownService = (function () {
    /**
     * @param {?} resolver
     * @param {?} appRef
     */
    function AsiDropdownService(resolver, appRef) {
        this.resolver = resolver;
        this.appRef = appRef;
        this.containers = [];
    }
    /**
     *
     * @param {?} elementRef
     * @param {?} asiDropDown
     * @return {?}
     */
    AsiDropdownService.prototype.showDropdown = function (elementRef, asiDropDown) {
        var _this = this;
        var /** @type {?} */ containerRef = this.getContainer();
        containerRef.instance.injectService(this);
        containerRef.instance.forElement(elementRef);
        containerRef.instance.show(asiDropDown);
        containerRef.instance.setIndex(this.containers.length);
        containerRef.instance.onClose().subscribe(function (containerToRemove) {
            remove(_this.containers, function (container) {
                return containerToRemove.index == container.instance.index;
            });
            console.log(_this.containers.length);
        });
        this.containers.push(containerRef);
        return containerRef;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    AsiDropdownService.prototype.canClose = function (index) {
        return index >= this.containers.length - 1;
    };
    /**
     * @return {?}
     */
    AsiDropdownService.prototype.getContainer = function () {
        //Récuperation du rootComponent
        var /** @type {?} */ rootComponent = this.appRef.components[0].instance;
        if (!rootComponent.viewContainerRef) {
            var /** @type {?} */ appName = this.appRef.componentTypes[0].name;
            throw new Error("AsiDropdown : Please add 'viewContainerRef : ViewContainerRef' declaration in your root component constructor : " + appName);
        }
        //Création d'un AsiDropdownContainer
        var /** @type {?} */ asiDropdownContainerFactory = this.resolver.resolveComponentFactory(AsiDropdownContainer);
        var /** @type {?} */ containerRef = rootComponent.viewContainerRef.createComponent(asiDropdownContainerFactory, 0);
        return containerRef;
    };
    AsiDropdownService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiDropdownService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
        { type: ApplicationRef, },
    ]; };
    return AsiDropdownService;
}());

var AsiDropDown = (function () {
    /**
     * @param {?} asiDropdownService
     * @param {?} elementRef
     */
    function AsiDropDown(asiDropdownService, elementRef) {
        this.asiDropdownService = asiDropdownService;
        this.elementRef = elementRef;
        this.open = false;
        this.calculWidth = true;
        this.onClose = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    AsiDropDown.prototype.ngOnChanges = function (changes) {
        var _this = this;
        // To open
        if (changes.open.currentValue) {
            setTimeout(function () {
                if (_this.relativeTo == null) {
                    _this.dropdown = _this.asiDropdownService.showDropdown(_this.elementRef.nativeElement.parentElement, _this);
                }
                else {
                    _this.dropdown = _this.asiDropdownService.showDropdown(_this.relativeTo.nativeElement, _this);
                }
                _this.dropdown.instance.setCalculWidth(_this.calculWidth);
                _this.dropdown.instance.onClose().subscribe(function () {
                    _this.destroyDropdown();
                });
            });
        }
        else if (this.dropdown) {
            this.dropdown.instance.close();
        }
    };
    /**
     * @return {?}
     */
    AsiDropDown.prototype.destroyDropdown = function () {
        this.open = false;
        this.onClose.emit();
        this.dropdown.destroy();
    };
    AsiDropDown.decorators = [
        { type: Component, args: [{
                    selector: 'asi-dropdown',
                    template: '<ng-template><div class="asi-dropdown"><ng-content></ng-content></div></ng-template>',
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDropDown.ctorParameters = function () { return [
        { type: AsiDropdownService, },
        { type: ElementRef, },
    ]; };
    AsiDropDown.propDecorators = {
        'open': [{ type: Input },],
        'calculWidth': [{ type: Input },],
        'relativeTo': [{ type: Input },],
        'onClose': [{ type: Output },],
        'contentTemplate': [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return AsiDropDown;
}());

var AsiDropdownModule = (function () {
    function AsiDropdownModule() {
    }
    /**
     * @return {?}
     */
    AsiDropdownModule.forRoot = function () {
        return {
            ngModule: AsiDropdownModule,
            providers: [AsiDropdownService]
        };
    };
    AsiDropdownModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiDropdownContainer, AsiDropDown],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiDropDown],
                    entryComponents: [AsiDropdownContainer],
                    providers: [AsiDropdownService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDropdownModule.ctorParameters = function () { return []; };
    return AsiDropdownModule;
}());

var AsiSelectModule = (function () {
    function AsiSelectModule() {
    }
    /**
     * @return {?}
     */
    AsiSelectModule.forRoot = function () {
        return {
            ngModule: AsiSelectModule,
            providers: []
        };
    };
    AsiSelectModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiSelectComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiCheckBoxModule.forRoot(), AsiDropdownModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiSelectComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiSelectModule.ctorParameters = function () { return []; };
    return AsiSelectModule;
}());

var AsiDmyPickerModule = (function () {
    function AsiDmyPickerModule() {
    }
    /**
     * @return {?}
     */
    AsiDmyPickerModule.forRoot = function () {
        return {
            ngModule: AsiDmyPickerModule,
            providers: []
        };
    };
    AsiDmyPickerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiDmyPickerComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiSelectModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiDmyPickerComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDmyPickerModule.ctorParameters = function () { return []; };
    return AsiDmyPickerModule;
}());

var AsiMomentService = (function () {
    function AsiMomentService() {
    }
    /**
     * @param {?} date
     * @param {?} dayNumber
     * @return {?}
     */
    AsiMomentService.prototype.addDays = function (date, dayNumber) {
        if (date != null && dayNumber != null) {
            return moment(date).add(dayNumber, "days").toDate();
        }
        else {
            return null;
        }
    };
    /**
     * @param {?} date
     * @param {?} monthNumber
     * @return {?}
     */
    AsiMomentService.prototype.addMonths = function (date, monthNumber) {
        if (date != null && monthNumber != null) {
            return moment(date).add(monthNumber, "months").toDate();
        }
        else {
            return null;
        }
    };
    /**
     * @param {?} date
     * @return {?}
     */
    AsiMomentService.prototype.formatToLocalDate = function (date) {
        return this.format(date, 'YYYY-MM-DD', 'YYYY-MM-DD');
    };
    /**
     * @param {?} date
     * @param {?=} pattern
     * @return {?}
     */
    AsiMomentService.prototype.formatDate = function (date, pattern) {
        return this.format(date, 'YYYY-MM-DD', pattern);
    };
    /**
     * @param {?} date
     * @param {?=} pattern
     * @return {?}
     */
    AsiMomentService.prototype.formatDateTime = function (date, pattern) {
        return this.format(date, 'YYYY-MM-DDTHH:mm:ss:SSSZ', pattern);
    };
    /**
     * @param {?} date
     * @param {?} baseFormat
     * @param {?=} pattern
     * @return {?}
     */
    AsiMomentService.prototype.format = function (date, baseFormat, pattern) {
        if (date == null) {
            return "";
        }
        if (pattern == null) {
            pattern = "DD/MM/YYYY";
        }
        var /** @type {?} */ aDate = date;
        if (typeof aDate == "string") {
            var /** @type {?} */ amoment = moment(aDate, baseFormat);
            return amoment.format(pattern);
        }
        return moment(date).format(pattern);
    };
    /**
     * @param {?} dateString
     * @param {?=} pattern
     * @return {?}
     */
    AsiMomentService.prototype.parse = function (dateString, pattern) {
        if (dateString == null) {
            return null;
        }
        if (pattern == null) {
            return moment(dateString);
        }
        return moment(dateString, pattern);
    };
    AsiMomentService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiMomentService.ctorParameters = function () { return []; };
    return AsiMomentService;
}());

var AsiDatePipe = (function () {
    /**
     * @param {?} asiMomentService
     */
    function AsiDatePipe(asiMomentService) {
        this.asiMomentService = asiMomentService;
    }
    /**
     * @param {?} date
     * @param {?} format
     * @return {?}
     */
    AsiDatePipe.prototype.transform = function (date, format) {
        return this.asiMomentService.format(date, format);
    };
    AsiDatePipe.decorators = [
        { type: Pipe, args: [{ name: 'asiDate' },] },
    ];
    /**
     * @nocollapse
     */
    AsiDatePipe.ctorParameters = function () { return [
        { type: AsiMomentService, },
    ]; };
    return AsiDatePipe;
}());

/**
 * Service de gestion de component
 */
var AsiComponentService = (function () {
    /**
     * @param {?} resolver
     */
    function AsiComponentService(resolver) {
        this.resolver = resolver;
    }
    /**
     * @template T
     * @param {?} content
     * @param {?} containerRef
     * @return {?}
     */
    AsiComponentService.prototype.createInstance = function (content, containerRef) {
        var /** @type {?} */ contentFactory = this.resolver.resolveComponentFactory(content);
        var /** @type {?} */ contentRef = containerRef.createComponent(contentFactory);
        return contentRef;
    };
    AsiComponentService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiComponentService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
    ]; };
    return AsiComponentService;
}());

var AsiCookieService = (function () {
    /**
     * @param {?} document
     */
    function AsiCookieService(document) {
        this.document = document;
    }
    /**
     * @return {?}
     */
    AsiCookieService.prototype.coockie = function () {
        return this.document.cookie;
    };
    AsiCookieService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiCookieService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
    ]; };
    return AsiCookieService;
}());

var AsiSessionStorageService = (function () {
    function AsiSessionStorageService() {
        this.sessionStorage = window.sessionStorage;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    AsiSessionStorageService.prototype.setItem = function (key, value) {
        this.sessionStorage.setItem(key, value);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    AsiSessionStorageService.prototype.getItem = function (key) {
        return this.sessionStorage.getItem(key);
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    AsiSessionStorageService.prototype.setObjectItem = function (key, value) {
        var /** @type {?} */ strValue = null;
        if (value != null) {
            strValue = JSON.stringify(value);
        }
        this.sessionStorage.setItem(key, strValue);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    AsiSessionStorageService.prototype.getObjectItem = function (key) {
        var /** @type {?} */ strValue = this.sessionStorage.getItem(key);
        var /** @type {?} */ value = null;
        if (strValue != null) {
            value = JSON.parse(strValue);
        }
        return value;
    };
    /**
     * @param {?} key
     * @return {?}
     */
    AsiSessionStorageService.prototype.removeItem = function (key) {
        this.sessionStorage.removeItem(key);
    };
    /**
     * @return {?}
     */
    AsiSessionStorageService.prototype.clear = function () {
        this.sessionStorage.clear();
    };
    AsiSessionStorageService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiSessionStorageService.ctorParameters = function () { return []; };
    return AsiSessionStorageService;
}());

var AsiPaginationService = (function () {
    function AsiPaginationService() {
    }
    /**
     * @param {?} datas
     * @param {?} nbElementParPage
     * @return {?}
     */
    AsiPaginationService.prototype.getNbPages = function (datas, nbElementParPage) {
        return Math.ceil(datas.length / nbElementParPage);
    };
    /**
     * @param {?} datas
     * @param {?} nbElementParPage
     * @param {?} pageIndex
     * @return {?}
     */
    AsiPaginationService.prototype.getPage = function (datas, nbElementParPage, pageIndex) {
        var /** @type {?} */ results = new Array();
        if (datas != null) {
            if (pageIndex < this.getNbPages(datas, nbElementParPage)) {
                results = datas.slice((pageIndex - 1) * nbElementParPage, (pageIndex) * nbElementParPage);
            }
            else {
                results = datas.slice((pageIndex - 1) * nbElementParPage);
            }
        }
        return results;
    };
    AsiPaginationService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiPaginationService.ctorParameters = function () { return []; };
    return AsiPaginationService;
}());

var AsiCssInjectorService = (function () {
    function AsiCssInjectorService() {
    }
    /**
     * @param {?} cssUrl
     * @return {?}
     */
    AsiCssInjectorService.prototype.injectCss = function (cssUrl) {
        document.getElementsByTagName("head")[0].appendChild(this.getCssTemplate(cssUrl));
    };
    /**
     * @param {?} cssUrl
     * @return {?}
     */
    AsiCssInjectorService.prototype.getCssTemplate = function (cssUrl) {
        var /** @type {?} */ link = document.createElement("link");
        link.href = cssUrl;
        link.type = "text/css";
        link.rel = "stylesheet";
        return link;
    };
    AsiCssInjectorService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiCssInjectorService.ctorParameters = function () { return []; };
    return AsiCssInjectorService;
}());

var /** @type {?} */ services = [AsiCssInjectorService,
    AsiFileService,
    AsiMomentService,
    AsiPaginationService,
    AsiSessionStorageService,
    AsiComponentService,
    AsiCookieService];
var AsiServicesModule = (function () {
    function AsiServicesModule() {
    }
    /**
     * @return {?}
     */
    AsiServicesModule.forRoot = function () {
        return {
            ngModule: AsiServicesModule,
            providers: services
        };
    };
    AsiServicesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                    entryComponents: [],
                    providers: services
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiServicesModule.ctorParameters = function () { return []; };
    return AsiServicesModule;
}());

/**
 * Pipe permettant de transformer un nombre en Array comprenant ce nombre ainsi que les autres le précedent
 * Exemple  : [innerHtml]="5 | toArray"
 */
var IntArrayPipe = (function () {
    function IntArrayPipe() {
    }
    /**
     * @param {?} max
     * @param {?=} first
     * @param {?=} step
     * @param {?=} reverse
     * @return {?}
     */
    IntArrayPipe.prototype.transform = function (max, first, step, reverse) {
        if (first == null) {
            first = 0;
        }
        if (step == null) {
            step = 1;
        }
        var /** @type {?} */ results = [];
        if (!reverse) {
            var /** @type {?} */ value = first;
            while (value <= max) {
                results.push(value);
                value = value + step;
            }
        }
        else {
            var /** @type {?} */ value = max;
            while (value >= first) {
                results.push(value);
                value = value - step;
            }
        }
        return results;
    };
    IntArrayPipe.decorators = [
        { type: Pipe, args: [{ name: 'intArray' },] },
    ];
    /**
     * @nocollapse
     */
    IntArrayPipe.ctorParameters = function () { return []; };
    return IntArrayPipe;
}());

/**
 * Pipe permettant de concatener des informations
 * items : les items à concatener
 * separator : le separator
 * property : la property à extraire des items
 */
var AsiConcatPipe = (function () {
    function AsiConcatPipe() {
    }
    /**
     * @param {?} items
     * @param {?} separator
     * @param {?=} property
     * @return {?}
     */
    AsiConcatPipe.prototype.transform = function (items, separator, property) {
        if (isEmpty(items)) {
            return "";
        }
        if (property != null) {
            var /** @type {?} */ itemsProperties = map(items, function (item) {
                return item[property];
            });
            return join(itemsProperties, separator);
        }
        return join(items, separator);
    };
    AsiConcatPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'asiConcat',
                    pure: false
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiConcatPipe.ctorParameters = function () { return []; };
    return AsiConcatPipe;
}());

/**
 * Pipe permettant de filter une liste d'information
 * value : valeur de reference pour le filtre
 * filter : peut être une fonction de filtrage ou une propriete de l'objet
 */
var AsiFilterPipe = (function () {
    function AsiFilterPipe() {
    }
    /**
     * @param {?} items
     * @param {?} value
     * @param {?} filter
     * @return {?}
     */
    AsiFilterPipe.prototype.transform = function (items, value, filter$$1) {
        var /** @type {?} */ result = [];
        if (items != null) {
            if (this.isFunction(filter$$1)) {
                result = items.filter(function (item) { return filter$$1(item, value); });
            }
            else if (value != null) {
                result = items.filter(function (item) { item[value].indexOf(value) !== -1; });
            }
        }
        return result;
    };
    /**
     * @param {?} functionToCheck
     * @return {?}
     */
    AsiFilterPipe.prototype.isFunction = function (functionToCheck) {
        var /** @type {?} */ getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    };
    AsiFilterPipe.decorators = [
        { type: Pipe, args: [{ name: 'asiFilter' },] },
    ];
    /**
     * @nocollapse
     */
    AsiFilterPipe.ctorParameters = function () { return []; };
    return AsiFilterPipe;
}());

/**
 * Pipe permettant de concatener des informations
 * items : les items à concatener
 * separator : le separator
 * base : la base du translate (permet de gerer des enums par exemple)
 * property : la property à extraite des items
 */
var AsiConcatTranslatePipe = (function () {
    /**
     * @param {?} translate
     */
    function AsiConcatTranslatePipe(translate) {
        this.translate = translate;
    }
    /**
     * @param {?} items
     * @param {?} separator
     * @param {?=} base
     * @param {?=} property
     * @return {?}
     */
    AsiConcatTranslatePipe.prototype.transform = function (items, separator, base, property) {
        var _this = this;
        if (isEmpty(items)) {
            return "";
        }
        if (property != null) {
            var /** @type {?} */ itemsTranslate_1 = map(items, function (item) {
                return _this.translate.instant(base + item[property]);
            });
            return join(itemsTranslate_1, separator);
        }
        var /** @type {?} */ itemsTranslate = map(items, function (item) {
            return _this.translate.instant(base + item);
        });
        return join(itemsTranslate, separator);
    };
    AsiConcatTranslatePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'asiConcatTranslate',
                    pure: false
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiConcatTranslatePipe.ctorParameters = function () { return [
        { type: TranslateService, },
    ]; };
    return AsiConcatTranslatePipe;
}());

var /** @type {?} */ sharedDeclarations = [AsiFilterPipe, AsiConcatPipe, AsiDatePipe, AsiConcatTranslatePipe, IntArrayPipe];
var AsiPipesModule = (function () {
    function AsiPipesModule() {
    }
    /**
     * @return {?}
     */
    AsiPipesModule.forRoot = function () {
        return {
            ngModule: AsiPipesModule,
            providers: []
        };
    };
    AsiPipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: sharedDeclarations.slice(),
                    imports: [AsiServicesModule.forRoot()],
                    exports: sharedDeclarations.slice(),
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiPipesModule.ctorParameters = function () { return []; };
    return AsiPipesModule;
}());

var MouseWheelDirective = (function () {
    function MouseWheelDirective() {
        this.mouseWheelUp = new EventEmitter();
        this.mouseWheelDown = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    MouseWheelDirective.prototype.onMouseWheelChrome = function (event) {
        this.mouseWheelFunc(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MouseWheelDirective.prototype.onMouseWheelFirefox = function (event) {
        this.mouseWheelFunc(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MouseWheelDirective.prototype.onMouseWheelIE = function (event) {
        this.mouseWheelFunc(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MouseWheelDirective.prototype.mouseWheelFunc = function (event) {
        var /** @type {?} */ event = window.event || event; // old IE support
        var /** @type {?} */ delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        if (delta > 0) {
            this.mouseWheelUp.emit(event);
        }
        else if (delta < 0) {
            this.mouseWheelDown.emit(event);
        }
        // for IE
        event.returnValue = false;
        // for Chrome and Firefox
        if (event.preventDefault) {
            event.preventDefault();
        }
    };
    MouseWheelDirective.decorators = [
        { type: Directive, args: [{ selector: '[mouseWheel]' },] },
    ];
    /**
     * @nocollapse
     */
    MouseWheelDirective.ctorParameters = function () { return []; };
    MouseWheelDirective.propDecorators = {
        'mouseWheelUp': [{ type: Output },],
        'mouseWheelDown': [{ type: Output },],
        'onMouseWheelChrome': [{ type: HostListener, args: ['mousewheel', ['$event'],] },],
        'onMouseWheelFirefox': [{ type: HostListener, args: ['DOMMouseScroll', ['$event'],] },],
        'onMouseWheelIE': [{ type: HostListener, args: ['onmousewheel', ['$event'],] },],
    };
    return MouseWheelDirective;
}());

/**
 * Directive permettant d'eviter la propagation du doubleclick a l'element parent
 */
var NoDblclickPropagration = (function () {
    function NoDblclickPropagration() {
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    NoDblclickPropagration.prototype.onMousedown = function ($event) {
        $event.stopPropagation();
    };
    NoDblclickPropagration.decorators = [
        { type: Directive, args: [{
                    selector: '[no-dblclick-propagation]'
                },] },
    ];
    /**
     * @nocollapse
     */
    NoDblclickPropagration.ctorParameters = function () { return []; };
    NoDblclickPropagration.propDecorators = {
        'onMousedown': [{ type: HostListener, args: ['dblclick', ['$event'],] },],
    };
    return NoDblclickPropagration;
}());

/**
 * Directive permettant d'eviter la propagation du click a l'element parent
 */
var NoClickPropagration = (function () {
    function NoClickPropagration() {
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    NoClickPropagration.prototype.onMousedown = function ($event) {
        $event.stopPropagation();
    };
    NoClickPropagration.decorators = [
        { type: Directive, args: [{
                    selector: '[no-click-propagation]'
                },] },
    ];
    /**
     * @nocollapse
     */
    NoClickPropagration.ctorParameters = function () { return []; };
    NoClickPropagration.propDecorators = {
        'onMousedown': [{ type: HostListener, args: ['mousedown', ['$event'],] },],
    };
    return NoClickPropagration;
}());

var FocusDirective = (function () {
    /**
     * @param {?} element
     */
    function FocusDirective(element) {
        this.element = element;
    }
    /**
     * @return {?}
     */
    FocusDirective.prototype.ngAfterViewInit = function () {
        this.element.nativeElement.focus();
    };
    FocusDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[focus]'
                },] },
    ];
    /**
     * @nocollapse
     */
    FocusDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    FocusDirective.propDecorators = {
        'focus': [{ type: Input },],
    };
    return FocusDirective;
}());

var AsiDirectivesModule = (function () {
    function AsiDirectivesModule() {
    }
    /**
     * @return {?}
     */
    AsiDirectivesModule.forRoot = function () {
        return {
            ngModule: AsiDirectivesModule,
            providers: []
        };
    };
    AsiDirectivesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [FocusDirective,
                        NoClickPropagration,
                        NoDblclickPropagration,
                        MouseWheelDirective],
                    imports: [],
                    exports: [FocusDirective,
                        NoClickPropagration,
                        NoDblclickPropagration,
                        MouseWheelDirective],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDirectivesModule.ctorParameters = function () { return []; };
    return AsiDirectivesModule;
}());

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiTinyMCE = (function (_super) {
    __extends$3(AsiTinyMCE, _super);
    /**
     * @param {?} zone
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiTinyMCE(zone, elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.zone = zone;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        return _this;
    }
    /**
     * @return {?}
     */
    AsiTinyMCE.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiTinyMCE.prototype.ngAfterViewInit = function () {
        var _this = this;
        tinymce.init({
            selector: '#' + this.elementId,
            plugins: ['link', 'paste', 'table', 'textcolor', 'colorpicker'],
            toolbar: " fontselect fontsizeselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent blockquote | forecolor backcolor",
            skin_url: '../assets/tinymce/skin',
            setup: function (editor) {
                _this.editor = editor;
                editor.on('keyup', function () {
                    _this.onModelChange();
                });
                editor.on('Change', function () {
                    _this.onModelChange();
                });
            },
            init_instance_callback: function (editor) {
                if (_this.value != null) {
                    editor.setContent(_this.value);
                }
            }
        });
    };
    /**
     * @return {?}
     */
    AsiTinyMCE.prototype.onModelChange = function () {
        var _this = this;
        this.zone.run(function () {
            var /** @type {?} */ content = _this.editor.getContent();
            _this.value = content;
            _this.onValueChange.emit(content);
        });
    };
    /**
     * @return {?}
     */
    AsiTinyMCE.prototype.ngOnDestroy = function () {
        tinymce.remove(this.editor);
    };
    AsiTinyMCE.decorators = [
        { type: Component, args: [{
                    selector: 'asi-tinymce',
                    template: "<textarea id=\"{{elementId}}\"></textarea>",
                    host: { 'class': 'asi-component asi-tinymce' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiTinyMCE; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTinyMCE.ctorParameters = function () { return [
        { type: NgZone, },
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiTinyMCE.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'elementId': [{ type: Input },],
    };
    return AsiTinyMCE;
}(DefaultControlValueAccessor));

var AsiTinyMCEModule = (function () {
    function AsiTinyMCEModule() {
    }
    /**
     * @return {?}
     */
    AsiTinyMCEModule.forRoot = function () {
        return {
            ngModule: AsiTinyMCEModule,
            providers: []
        };
    };
    AsiTinyMCEModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiTinyMCE],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiTinyMCE],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTinyMCEModule.ctorParameters = function () { return []; };
    return AsiTinyMCEModule;
}());

var AsiMenuItem = (function () {
    function AsiMenuItem() {
        this.disabled = false;
        this.onClick = new EventEmitter();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    AsiMenuItem.prototype.emitClick = function ($event) {
        this.onClick.emit($event);
    };
    AsiMenuItem.decorators = [
        { type: Component, args: [{
                    selector: 'asi-menu-item',
                    template: '<ng-template><ng-content></ng-content></ng-template>'
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiMenuItem.ctorParameters = function () { return []; };
    AsiMenuItem.propDecorators = {
        'routerLink': [{ type: Input },],
        'disabled': [{ type: Input },],
        'onClick': [{ type: Output },],
        'template': [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return AsiMenuItem;
}());

var AsiMenu = (function () {
    function AsiMenu() {
        this.burger = false;
        this.vertical = false;
        this.items = new Array();
    }
    /**
     * @return {?}
     */
    AsiMenu.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    AsiMenu.prototype.toggleBurger = function () {
        this.burgerOpen = !this.burgerOpen;
    };
    /**
     * @return {?}
     */
    AsiMenu.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.items = [];
        this.queryItems.forEach(function (item) {
            _this.items.push(item);
        });
        this.queryItems.changes.subscribe(function (items) {
            _this.items = items;
        });
        this.burgerOpen = !this.burger;
    };
    AsiMenu.decorators = [
        { type: Component, args: [{
                    selector: 'asi-menu',
                    template: "<div class=\"asi-menu-container\"> <span *ngIf=\"burger\" (click)=\"toggleBurger()\"> <ng-template *ngIf=\"burgerTemplate != null\" [ngTemplateOutlet]=\"burgerTemplate\"></ng-template> </span> <div class=\"asi-menu-panel\"> <div *ngIf=\"burgerOpen\" class=\"items-container\" [ngClass]=\"{'vertical' : vertical, 'burger' : burger }\"> <button *ngFor=\"let item of items\" class=\"item-container\" routerLinkActive=\"active\" [routerLink]=\"item.routerLink\" [disabled]=\"disabled || item.disabled\" (click)=\"item.emitClick($event)\"> <ng-template *ngIf=\"item.template != null\" [ngTemplateOutlet]=\"item.template\"></ng-template> </button> </div> </div> </div>",
                    host: { 'class': 'asi-component asi-menu' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiMenu.ctorParameters = function () { return []; };
    AsiMenu.propDecorators = {
        'burger': [{ type: Input },],
        'vertical': [{ type: Input },],
        'items': [{ type: Input },],
        'queryItems': [{ type: ContentChildren, args: [AsiMenuItem,] },],
        'burgerTemplate': [{ type: ContentChild, args: ["burger",] },],
    };
    return AsiMenu;
}());

var AsiMenuModule = (function () {
    function AsiMenuModule() {
    }
    /**
     * @return {?}
     */
    AsiMenuModule.forRoot = function () {
        return {
            ngModule: AsiMenuModule,
            providers: []
        };
    };
    AsiMenuModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiMenu, AsiMenuItem],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiMenu, AsiMenuItem],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiMenuModule.ctorParameters = function () { return []; };
    return AsiMenuModule;
}());

var __extends$4 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiTextareaComponent = (function (_super) {
    __extends$4(AsiTextareaComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiTextareaComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.placeholder = "";
        _this.labelPosition = "top";
        _this.rows = 1;
        _this.maxlength = -1;
        _this.textareaControl = new FormControl();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiTextareaComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiTextareaComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.textareaControl.valueChanges.subscribe(function (value) {
            if (value == "") {
                _this.value = null;
            }
            else if (_this.isValide(value)) {
                _this.value = value;
            }
            else if (_this.maxlength != -1 && value.length > _this.maxlength) {
                //si la taille n'est pas respectée on coupe
                _this.value = value.substr(0, _this.maxlength);
            }
            _this.textareaElm.nativeElement.value = _this._value;
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiTextareaComponent.prototype.isValide = function (value) {
        return value == null || ((this.maxlength == -1 || value.length <= this.maxlength)
            && (this.pattern == null || this.pattern.test(value)));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiTextareaComponent.prototype.writeValue = function (value) {
        if (this.isValide(value)) {
            this.textareaControl.setValue(value, { emitEvent: false });
        }
        else if (this.maxlength != -1 && value.length > this.maxlength) {
            //Length incorrect on truncate
            this.textareaControl.setValue(truncate(value, { length: this.maxlength }), { emitEvent: false });
        }
        else {
            //Pattern incorrect
            this.textareaElm.nativeElement.value = "Incorrect value";
        }
    };
    AsiTextareaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-textarea',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <textarea #textarea [attr.rows]=\"rows\" class=\"asi-focus-error\" [attr.disabled]=\"disabled ? '' : null\" [placeholder]=\"placeholder\" [formControl]=\"textareaControl\"></textarea>",
                    host: { 'class': 'asi-component asi-textarea' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiTextareaComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTextareaComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiTextareaComponent.propDecorators = {
        'label': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'rows': [{ type: Input },],
        'maxlength': [{ type: Input },],
        'pattern': [{ type: Input },],
        'textareaElm': [{ type: ViewChild, args: ["textarea",] },],
    };
    return AsiTextareaComponent;
}(DefaultControlValueAccessor));

var AsiTextareaModule = (function () {
    function AsiTextareaModule() {
    }
    /**
     * @return {?}
     */
    AsiTextareaModule.forRoot = function () {
        return {
            ngModule: AsiTextareaModule,
            providers: []
        };
    };
    AsiTextareaModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiTextareaComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiTextareaComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTextareaModule.ctorParameters = function () { return []; };
    return AsiTextareaModule;
}());

var AsiTableInliner = (function () {
    function AsiTableInliner() {
    }
    AsiTableInliner.decorators = [
        { type: Directive, args: [{
                    selector: 'asi-table-inliner',
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTableInliner.ctorParameters = function () { return []; };
    AsiTableInliner.propDecorators = {
        'colSpan': [{ type: Input },],
        'template': [{ type: ContentChild, args: ["inliner",] },],
    };
    return AsiTableInliner;
}());

var AsiTableColumn = (function () {
    function AsiTableColumn() {
        this.inversSort = false;
        this.sortable = false;
        this.inlineColumn = false;
        this.type = 'text';
        this.onChecked = new EventEmitter();
        this.onAllChecked = new EventEmitter();
        this.asc = null;
        this.inliners = new Array();
        this.asc = this.sortByDefault;
    }
    /**
     * @return {?}
     */
    AsiTableColumn.prototype.toggleSort = function () {
        return this.asc = !this.asc;
    };
    /**
     * @return {?}
     */
    AsiTableColumn.prototype.unsort = function () {
        this.asc = null;
    };
    /**
     * @return {?}
     */
    AsiTableColumn.prototype.getAsc = function () {
        return this.inversSort ? !this.asc : this.asc;
    };
    /**
     * @return {?}
     */
    AsiTableColumn.prototype.getSortName = function () {
        return this.sortName != null ? this.sortName : this.name;
    };
    /**
     * @return {?}
     */
    AsiTableColumn.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.queryColumns.forEach(function (inlined) {
            _this.inliners.push(inlined);
        });
    };
    AsiTableColumn.decorators = [
        { type: Directive, args: [{
                    selector: 'asi-table-column',
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTableColumn.ctorParameters = function () { return []; };
    AsiTableColumn.propDecorators = {
        'name': [{ type: Input },],
        'sortName': [{ type: Input },],
        'libelle': [{ type: Input },],
        'showIf': [{ type: Input },],
        'hideIf': [{ type: Input },],
        'inversSort': [{ type: Input },],
        'sortable': [{ type: Input },],
        'sortByDefault': [{ type: Input },],
        'columnClass': [{ type: Input },],
        'inlineColumn': [{ type: Input },],
        'type': [{ type: Input },],
        'onChecked': [{ type: Output },],
        'onAllChecked': [{ type: Output },],
        'template': [{ type: ContentChild, args: ["column",] },],
        'headerTemplate': [{ type: ContentChild, args: ["header",] },],
        'queryColumns': [{ type: ContentChildren, args: [AsiTableInliner,] },],
    };
    return AsiTableColumn;
}());

var AsiPaginationComponent = (function () {
    function AsiPaginationComponent() {
        this.nbElements = 0;
        this.nbVisibleElements = 0;
        this.selectedPagination = 1;
        this.onPaginationChanged = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.onFirstPage = function () {
        return this.selectedPagination === 1;
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.onLastPage = function () {
        return this.selectedPagination === this.nbElements;
    };
    /**
     * @param {?} pagination
     * @return {?}
     */
    AsiPaginationComponent.prototype.isCurrentPagination = function (pagination) {
        return this.selectedPagination === pagination;
    };
    /**
     * @param {?} pagination
     * @return {?}
     */
    AsiPaginationComponent.prototype.changePagination = function (pagination) {
        if (pagination != AsiPaginationComponent.TRI_POINT) {
            this.selectedPagination = pagination;
            this.onPaginationChanged.emit(this.selectedPagination);
        }
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.previousPage = function () {
        if (this.selectedPagination > 1) {
            this.selectedPagination--;
            this.onPaginationChanged.emit(this.selectedPagination);
        }
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.nextPage = function () {
        if (this.selectedPagination < this.nbElements) {
            this.selectedPagination++;
            this.onPaginationChanged.emit(this.selectedPagination);
        }
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.goLastPage = function () {
        this.selectedPagination = this.nbElements;
        this.onPaginationChanged.emit(this.selectedPagination);
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.goFirstPage = function () {
        this.selectedPagination = 1;
        this.onPaginationChanged.emit(this.selectedPagination);
    };
    /**
     * @return {?}
     */
    AsiPaginationComponent.prototype.getPaginationItems = function () {
        var /** @type {?} */ currentPage = this.selectedPagination;
        var /** @type {?} */ halfVisibleElement = Math.floor(this.nbVisibleElements / 2);
        if (!this.nbElements) {
            this.nbElements = 1;
        }
        if (this.nbElements <= this.nbVisibleElements) {
            //Affichage complet
            return this.createNumbersTab(1, this.nbElements);
        }
        else if (currentPage < halfVisibleElement + 2) {
            //Debut de la pagination
            return concat(this.createNumbersTab(1, this.nbVisibleElements - 1), [AsiPaginationComponent.TRI_POINT, this.nbElements]);
        }
        else if (currentPage > this.nbElements - halfVisibleElement) {
            //Fin de la pagination
            return concat([1, AsiPaginationComponent.TRI_POINT], this.createNumbersTab(this.nbElements - this.nbVisibleElements + 2, this.nbElements));
        }
        else {
            // Entre les deux
            return concat([1, AsiPaginationComponent.TRI_POINT], this.createNumbersTab(currentPage - halfVisibleElement + 1, currentPage + halfVisibleElement - 1), [AsiPaginationComponent.TRI_POINT, this.nbElements]);
        }
    };
    /**
     * @param {?} min
     * @param {?} max
     * @return {?}
     */
    AsiPaginationComponent.prototype.createNumbersTab = function (min, max) {
        var /** @type {?} */ index = min - 1;
        return times(max - min + 1, function () {
            return ++index;
        });
    };
    AsiPaginationComponent.TRI_POINT = '...';
    AsiPaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-pagination',
                    template: "<div class=\"action-panel\"> <div [ngClass]=\"{ 'disabled' : onFirstPage()}\"> <span (click)=\"goFirstPage()\" class=\"paginate-boutton action\" [innerHTML]=\"'&#139;&#139;'\"></span> <span (click)=\"previousPage()\" class=\"paginate-boutton action\" [innerHTML]=\"'&#139;'\"></span> </div> </div> <span *ngFor=\"let paginationItem of getPaginationItems()\" [ngClass]=\"{'selected' : isCurrentPagination(paginationItem) , 'paginate-boutton' : paginationItem != '...'}\" (click)=\"changePagination(paginationItem)\" [innerHTML]=\"paginationItem\"></span> <div class=\"action-panel\"> <div [ngClass]=\"{ 'disabled' : onLastPage()}\"> <span (click)=\"nextPage()\" class=\"paginate-boutton action\" [innerHTML]=\"'&#155;'\"></span> <span (click)=\"goLastPage()\" class=\"paginate-boutton action\" [innerHTML]=\"'&#155;&#155;'\"></span> </div> </div>",
                    host: { 'class': 'asi-component asi-pagination' }
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiPaginationComponent.ctorParameters = function () { return []; };
    AsiPaginationComponent.propDecorators = {
        'nbElements': [{ type: Input },],
        'nbVisibleElements': [{ type: Input },],
        'selectedPagination': [{ type: Input },],
        'onPaginationChanged': [{ type: Output },],
    };
    return AsiPaginationComponent;
}());

var AsiPaginationModule = (function () {
    function AsiPaginationModule() {
    }
    /**
     * @return {?}
     */
    AsiPaginationModule.forRoot = function () {
        return {
            ngModule: AsiPaginationModule,
            providers: []
        };
    };
    AsiPaginationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiPaginationComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiPaginationComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiPaginationModule.ctorParameters = function () { return []; };
    return AsiPaginationModule;
}());

var AsiTableSelectionModel = (function () {
    /**
     * @param {?} selectionId
     * @param {?} multipage
     */
    function AsiTableSelectionModel(selectionId, multipage) {
        this.nbItemsSelected = 0;
        this.itemsIncluded = [];
        this.itemsExcluded = [];
        this.allChecked = false;
        this.config = {
            selectionId: selectionId,
            multipage: multipage
        };
    }
    return AsiTableSelectionModel;
}());

var AsiTableRequest = (function () {
    function AsiTableRequest() {
    }
    return AsiTableRequest;
}());

var AsiTableData = (function () {
    function AsiTableData() {
        this.pageIndex = 1;
        this.results = null;
        this.totalElements = 0;
        this.totalPages = 0;
        this.paginate = false;
    }
    return AsiTableData;
}());

var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var AsiTable = (function () {
    /**
     * @param {?} paginateService
     */
    function AsiTable(paginateService) {
        this.paginateService = paginateService;
        this.autoSort = false;
        this.autoPaginate = false;
        this.nbElementParPage = 25;
        this.selectionModel = new AsiTableSelectionModel("id", false);
        this.fireRefreshOnInit = true;
        this.changePageOnTop = false;
        this.onRequestData = new EventEmitter();
        this.columns = new Array();
        this.data = new AsiTableData();
        this.searchDone = false;
        this.loading = false;
        //Affichage de la coche allchecked
        this.allChecked = false;
    }
    /**
     * @return {?}
     */
    AsiTable.prototype.getColumns = function () {
        var _this = this;
        return filter(this.columns, function (column) {
            return _this.filtreColumn(column);
        });
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.getInlineColumns = function () {
        return filter(this.columns, function (column) {
            return column.inlineColumn;
        });
    };
    /**
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.filtreColumn = function (column) {
        return (column.showIf == null || column.showIf) && (column.hideIf == null || !column.hideIf)
            && !column.inlineColumn;
    };
    /**
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.getHeaderClass = function (column) {
        var /** @type {?} */ columnClass = {};
        if (column.columnClass != null) {
            if (column.columnClass instanceof Object) {
                //Copy
                columnClass = __assign({}, column.columnClass);
            }
            else if (typeof column.columnClass === "string") {
                columnClass['' + column.columnClass] = true;
            }
        }
        columnClass.sortable = column.sortable;
        columnClass.asc = column.asc;
        columnClass.desc = column.asc === false;
        return columnClass;
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.fireRefresh = function () {
        this.data.pageIndex = 1;
        this.requestData();
        this.resetSelectionModel();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AsiTable.prototype.updateData = function (data) {
        this.data = data;
        if (this.autoPaginate) {
            this.noPaginateResults = data.results;
            this.paginateDatas();
        }
        else {
            this.initCheckbox();
        }
        if (this.autoSort) {
            this.sortDatas();
        }
    };
    /**
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.onSort = function (column) {
        if (column.sortable) {
            if (this.sortedColumn != null && this.sortedColumn != column) {
                this.sortedColumn.unsort();
            }
            this.sortedColumn = column;
            column.toggleSort();
            if (this.autoSort) {
                this.sortDatas();
            }
            else {
                this.requestData();
            }
        }
    };
    /**
     * @param {?} pagination
     * @return {?}
     */
    AsiTable.prototype.onPaginationChanged = function (pagination) {
        this.data.pageIndex = pagination;
        if (this.autoPaginate) {
            this.paginateDatas();
        }
        else {
            this.requestData();
        }
        if (this.changePageOnTop) {
            this.topElement.nativeElement.scrollIntoView();
        }
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.paginateDatas = function () {
        this.data.results = this.paginateService.getPage(this.noPaginateResults, this.nbElementParPage, this.data.pageIndex);
        this.data.totalPages = this.paginateService.getNbPages(this.noPaginateResults, this.nbElementParPage);
        this.data.totalElements = this.noPaginateResults.length;
        this.initCheckbox();
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.requestData = function () {
        var /** @type {?} */ request = this.getAsiTableRequest();
        this.onRequestData.emit(request);
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.getAsiTableRequest = function () {
        var /** @type {?} */ request = new AsiTableRequest();
        request.pageIndex = this.data.pageIndex;
        request.nbElementsParPage = this.nbElementParPage;
        if (this.sortedColumn != null) {
            request.tri = this.sortedColumn.getSortName();
            request.asc = this.sortedColumn.getAsc();
        }
        return request;
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.sortDatas = function () {
        if (this.sortedColumn != null) {
            this.data.results = orderBy(this.data.results, [this.sortedColumn.getSortName()], [this.sortedColumn.getAsc() ? 'asc' : 'desc']);
            this.loading = false;
        }
    };
    /**
     * Recupere la valeur à afficher pour une cellule
     * @param {?} row
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.getCellValue = function (row, column) {
        return this.getProperty(row, column.name);
    };
    /**
     * @param {?} object
     * @param {?} path
     * @return {?}
     */
    AsiTable.prototype.getProperty = function (object, path) {
        return get(object, path);
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.initCheckbox = function () {
        var _this = this;
        this.columns.forEach(function (column) {
            if (column.type == 'checkbox') {
                if (_this.selectionModel.allChecked) {
                    //Si est en mode allchecked on deselection les ligne excluent
                    forEach(_this.data.results, function (item) {
                        var /** @type {?} */ itemId = _this.getProperty(item, _this.selectionModel.config.selectionId);
                        var /** @type {?} */ excluded = find(_this.selectionModel.itemsExcluded, function (excludeditem) {
                            return _this.matchRow(itemId, excludeditem);
                        }) != null;
                        item.checked = !excluded;
                    });
                }
                else {
                    //Sinon on selectionne les lignes incluent
                    forEach(_this.data.results, function (item) {
                        var /** @type {?} */ itemId = _this.getProperty(item, _this.selectionModel.config.selectionId);
                        var /** @type {?} */ included = find(_this.selectionModel.itemsIncluded, function (includedItem) {
                            return _this.matchRow(itemId, includedItem);
                        }) != null;
                        item.checked = included;
                    });
                }
            }
        });
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.resetSelectionModel = function () {
        this.selectionModel.allChecked = false;
        this.selectionModel.nbItemsSelected = 0;
        this.selectionModel.itemsExcluded = [];
        this.selectionModel.itemsIncluded = [];
        this.initCheckbox();
    };
    /**
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.onAllChecked = function (column) {
        var _this = this;
        this.selectionModel.allChecked = this.allChecked;
        this.selectionModel.itemsIncluded = [];
        this.selectionModel.itemsExcluded = [];
        forEach(this.data.results, function (data) {
            data.checked = _this.selectionModel.allChecked;
        });
        if (this.selectionModel.allChecked) {
            if (this.selectionModel.config.multipage) {
                this.selectionModel.nbItemsSelected = this.data.totalElements;
            }
            else {
                this.selectionModel.nbItemsSelected = this.data.results.length;
            }
        }
        else {
            this.selectionModel.nbItemsSelected = 0;
        }
        column.onAllChecked.emit(this.selectionModel.allChecked);
    };
    /**
     * @param {?} row
     * @param {?} column
     * @return {?}
     */
    AsiTable.prototype.onChecked = function (row, column) {
        var _this = this;
        var /** @type {?} */ rowId = this.getProperty(row, this.selectionModel.config.selectionId);
        if (this.selectionModel.allChecked) {
            if (row.checked) {
                remove(this.selectionModel.itemsExcluded, function (item) {
                    return _this.matchRow(rowId, item);
                });
                this.selectionModel.nbItemsSelected++;
            }
            else {
                this.selectionModel.itemsExcluded.push(row);
                this.selectionModel.nbItemsSelected--;
            }
        }
        else {
            if (row.checked) {
                this.selectionModel.itemsIncluded.push(row);
                this.selectionModel.nbItemsSelected++;
            }
            else {
                remove(this.selectionModel.itemsIncluded, function (item) {
                    return _this.matchRow(rowId, item);
                });
                this.selectionModel.nbItemsSelected--;
            }
        }
        column.onChecked.emit(row);
        this.updateAllChecked();
    };
    /**
     * @param {?} rowId
     * @param {?} rowToMatch
     * @return {?}
     */
    AsiTable.prototype.matchRow = function (rowId, rowToMatch) {
        return rowId == this.getProperty(rowToMatch, this.selectionModel.config.selectionId);
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.updateAllChecked = function () {
        if (this.selectionModel.config.multipage) {
            this.allChecked = this.selectionModel.nbItemsSelected == this.data.totalElements;
        }
        else {
            this.allChecked = this.selectionModel.nbItemsSelected == this.data.results.length;
        }
    };
    /**
     * @param {?} row
     * @return {?}
     */
    AsiTable.prototype.getRowClass = function (row) {
        if (row != null && this.rowClass != null) {
            if (this.isFunction(this.rowClass)) {
                return this.rowClass(row);
            }
            else {
                var /** @type {?} */ rowClassStr = JSON.stringify(this.rowClass);
                rowClassStr = replace(rowClassStr, new RegExp('{row}', 'g'), 'row');
                rowClassStr = replace(rowClassStr, new RegExp("'", 'g'), '"');
                var /** @type {?} */ jsonRowClass = JSON.parse(rowClassStr);
                for (var /** @type {?} */ key in jsonRowClass) {
                    if (jsonRowClass.hasOwnProperty(key)) {
                        jsonRowClass[key] = eval(jsonRowClass[key]);
                    }
                }
                return jsonRowClass;
            }
        }
    };
    /**
     * @param {?} functionToCheck
     * @return {?}
     */
    AsiTable.prototype.isFunction = function (functionToCheck) {
        var /** @type {?} */ getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    };
    /**
     * @return {?}
     */
    AsiTable.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.queryColumns.forEach(function (column) {
            _this.columns.push(column);
        });
        if (this.fireRefreshOnInit) {
            this.requestData();
            this.resetSelectionModel();
        }
    };
    AsiTable.decorators = [
        { type: Component, args: [{
                    selector: 'asi-table',
                    template: "<table #table> <thead> <tr> <th *ngFor=\"let column of getColumns()\" [ngClass]=\"getHeaderClass(column)\" (click)=\"onSort(column)\"> <ng-container *ngIf=\"column.type == 'text'\"> <span class=\"header\"> <span *ngIf=\"!column.headerTemplate\">{{column.libelle | translate}}</span> <ng-template *ngIf=\"column.headerTemplate\" [ngTemplateOutlet]=\"column.headerTemplate\" [ngOutletContext]=\"{column : column}\"></ng-template> <span class=\"sortIconAsc\" [innerHtml]=\"'&#9660;'\"></span> <span class=\"sortIconDesc\" [innerHtml]=\"'&#9650;'\"></span> </span> </ng-container> <asi-checkbox *ngIf=\"column.type == 'checkbox'\" [(ngModel)]=\"allChecked\" (onValueChange)=\"onAllChecked(column)\"></asi-checkbox> </th> </tr> </thead> <ng-container *ngFor=\"let row of data?.results\"> <tbody [ngClass]=\"getRowClass(row)\"> <tr> <td *ngFor=\"let column of getColumns()\" [ngClass]=\"column.columnClass\"> <ng-container *ngIf=\"column.type == 'text'\"> <span *ngIf=\"!column.template\">{{getCellValue(row, column)}}</span> <ng-template *ngIf=\"column.template\" [ngTemplateOutlet]=\"column.template\" [ngOutletContext]=\"{row : row}\"></ng-template> </ng-container> <asi-checkbox *ngIf=\"column.type == 'checkbox'\" [(ngModel)]=\"row.checked\" (onValueChange)=\"onChecked(row, column)\"></asi-checkbox> </td> </tr> <tr *ngFor=\"let inlineColumn of getInlineColumns()\" class=\"inlined\"> <td *ngIf=\"inlineColumn.inliners.length == 0\" [attr.colspan]=\"getColumns().length\" class=\"inlined\" [ngClass]=\"inlineColumn.columnClass\"> <span *ngIf=\"!inlineColumn.template\">{{getCellValue(row, inlineColumn)}}</span> <ng-template *ngIf=\"inlineColumn.template\" [ngTemplateOutlet]=\"inlineColumn.template\" [ngOutletContext]=\"{row : row}\"></ng-template> </td> <ng-container *ngIf=\"inlineColumn.inliners.length > 0\"> <td *ngFor=\"let inliner of inlineColumn.inliners\" [attr.colspan]=\"inliner.colSpan\"> <span *ngIf=\"!inliner.template\">{{getCellValue(row, inlineColumn)}}</span> <ng-template *ngIf=\"inliner.template\" [ngTemplateOutlet]=\"inliner.template\" [ngOutletContext]=\"{row : row}\"></ng-template> </td> </ng-container> </tr> </tbody> </ng-container> </table> <asi-pagination *ngIf=\"data.paginate\" [nbElements]=\"data.totalPages\" [nbVisibleElements]=\"6\" [selectedPagination]=\"data.pageIndex\" (onPaginationChanged)=\"onPaginationChanged($event)\"></asi-pagination>",
                    host: { 'class': 'asi-component asi-table' }
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTable.ctorParameters = function () { return [
        { type: AsiPaginationService, },
    ]; };
    AsiTable.propDecorators = {
        'queryColumns': [{ type: ContentChildren, args: [AsiTableColumn,] },],
        'autoSort': [{ type: Input },],
        'autoPaginate': [{ type: Input },],
        'nbElementParPage': [{ type: Input },],
        'selectionModel': [{ type: Input },],
        'rowClass': [{ type: Input },],
        'fireRefreshOnInit': [{ type: Input },],
        'changePageOnTop': [{ type: Input },],
        'onRequestData': [{ type: Output },],
        'topElement': [{ type: ViewChild, args: ["table",] },],
    };
    return AsiTable;
}());

var AsiTableModule = (function () {
    function AsiTableModule() {
    }
    /**
     * @return {?}
     */
    AsiTableModule.forRoot = function () {
        return {
            ngModule: AsiTableModule,
            providers: [AsiPaginationService]
        };
    };
    AsiTableModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiTable, AsiTableColumn, AsiTableInliner],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiPaginationModule.forRoot(), AsiCheckBoxModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiTable, AsiTableColumn, AsiTableInliner],
                    entryComponents: [],
                    providers: [AsiPaginationService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTableModule.ctorParameters = function () { return []; };
    return AsiTableModule;
}());

var __extends$5 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiSwitchComponent = (function (_super) {
    __extends$5(AsiSwitchComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiSwitchComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.disabled = false;
        _this.labelPosition = "top";
        return _this;
    }
    /**
     * @return {?}
     */
    AsiSwitchComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiSwitchComponent.prototype.switch = function () {
        this.value = !this.value;
    };
    AsiSwitchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-switch',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <button type=\"button\" [disabled]=\"disabled\" (click)=\"switch()\" class=\"switch asi-focus-error\" [ngClass]=\"{ 'checked': value }\"> <span class=\"switch-button\"></span> </button>",
                    host: { 'class': 'asi-component asi-switch' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiSwitchComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiSwitchComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiSwitchComponent.propDecorators = {
        'label': [{ type: Input },],
        'disabled': [{ type: Input },],
        'labelPosition': [{ type: Input },],
    };
    return AsiSwitchComponent;
}(DefaultControlValueAccessor));

var AsiSwitchModule = (function () {
    function AsiSwitchModule() {
    }
    /**
     * @return {?}
     */
    AsiSwitchModule.forRoot = function () {
        return {
            ngModule: AsiSwitchModule,
            providers: []
        };
    };
    AsiSwitchModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiSwitchComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiSwitchComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiSwitchModule.ctorParameters = function () { return []; };
    return AsiSwitchModule;
}());

var AsiFaIconComponent = (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiFaIconComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.labelPosition = "top";
        this.submit = false;
        this.size = null;
        this.tooltipPosition = "bottom";
        this.noClickOnLabel = false;
        this.onClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AsiFaIconComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        this.renderer.addClass(this.tooltipElement.nativeElement, "tooltip-" + this.tooltipPosition);
        var /** @type {?} */ icons = this.icon.trim().split(" ");
        icons.forEach(function (icon) {
            _this.renderer.addClass(_this.iconElement.nativeElement, icon);
        });
        if (this.size != null) {
            this.renderer.addClass(this.iconElement.nativeElement, "fa-" + this.size);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AsiFaIconComponent.prototype.click = function (event) {
        if (!this.disabled) {
            this.onClick.emit(event);
        }
    };
    AsiFaIconComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-fa-icon',
                    template: "<label (click)=\"!noClickOnLabel && click()\" class=\"input-label\" [ngClass]=\"{'enabled' : !disabled && !noClickOnLabel}\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"icon-panel\"> <button [disabled]=\"disabled\" [attr.type]=\"submit ? 'submit' : 'button'\" (click)=\"click($event)\" #icon class=\"fa \" aria-hidden=\"true \"> <div class=\"asi-tooltip\" #tooltipView > <span class=\"tooltip-item\" *ngIf=\"tooltip !=null \" [translate]=\"tooltip \"></span> </div> </button> </div>",
                    host: { 'class': 'asi-component asi-fa-icon' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiFaIconComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiFaIconComponent.propDecorators = {
        'icon': [{ type: Input },],
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'submit': [{ type: Input },],
        'size': [{ type: Input },],
        'disabled': [{ type: Input },],
        'tooltip': [{ type: Input },],
        'tooltipPosition': [{ type: Input },],
        'noClickOnLabel': [{ type: Input },],
        'onClick': [{ type: Output },],
        'tooltipElement': [{ type: ViewChild, args: ["tooltipView",] },],
        'iconElement': [{ type: ViewChild, args: ["icon",] },],
    };
    return AsiFaIconComponent;
}());

var AsiFaIconModule = (function () {
    function AsiFaIconModule() {
    }
    /**
     * @return {?}
     */
    AsiFaIconModule.forRoot = function () {
        return {
            ngModule: AsiFaIconModule,
            providers: []
        };
    };
    AsiFaIconModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiFaIconComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiFaIconComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiFaIconModule.ctorParameters = function () { return []; };
    return AsiFaIconModule;
}());

/**
 * Class de configuration
 */
var AsiNotificationConfig = (function () {
    function AsiNotificationConfig() {
    }
    return AsiNotificationConfig;
}());
/**
 * Les differentes positions d'affichage possible
 */
var AsiNotificationPosition = (function () {
    /**
     * @param {?} value
     */
    function AsiNotificationPosition(value) {
        this.value = value;
    }
    /**
     * @return {?}
     */
    AsiNotificationPosition.prototype.toString = function () {
        return this.value;
    };
    AsiNotificationPosition.TOP_LEFT = new AsiNotificationPosition("top_left");
    AsiNotificationPosition.TOP_RIGHT = new AsiNotificationPosition("top_right");
    AsiNotificationPosition.TOP_CENTER = new AsiNotificationPosition("top_center");
    AsiNotificationPosition.BOTTOM_LEFT = new AsiNotificationPosition("bottom_left");
    AsiNotificationPosition.BOTTOM_RIGHT = new AsiNotificationPosition("bottom_right");
    AsiNotificationPosition.BOTTOM_CENTER = new AsiNotificationPosition("bottom_center");
    return AsiNotificationPosition;
}());
/**
 * Les differents type de notification possible
 */
var AsiNotificationType = (function () {
    /**
     * @param {?} value
     */
    function AsiNotificationType(value) {
        this.value = value;
    }
    /**
     * @return {?}
     */
    AsiNotificationType.prototype.toString = function () {
        return this.value;
    };
    AsiNotificationType.SUCCESS = new AsiNotificationType("success");
    AsiNotificationType.INFO = new AsiNotificationType("info");
    AsiNotificationType.ERROR = new AsiNotificationType("error");
    AsiNotificationType.WARNING = new AsiNotificationType("warning");
    return AsiNotificationType;
}());

var AsiNotification = (function () {
    /**
     * @param {?} viewContainerRef
     * @param {?} renderer
     * @param {?} element
     */
    function AsiNotification(viewContainerRef, renderer, element) {
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.element = element;
        this.icon = "fa-check";
        this.withIcon = false;
    }
    /**
     * @return {?}
     */
    AsiNotification.prototype.getComponent = function () {
        return this._component;
    };
    /**
     * @param {?} config
     * @return {?}
     */
    AsiNotification.prototype.setConfig = function (config) {
        this._config = config;
        this.withIcon = config.withIcon ? config.withIcon : false;
        switch (config.type) {
            case AsiNotificationType.SUCCESS:
                this.icon = "fa-check";
                break;
            case AsiNotificationType.INFO:
                this.icon = "fa-info";
                break;
            case AsiNotificationType.WARNING:
            case AsiNotificationType.ERROR:
                this.icon = "fa-exclamation";
                break;
        }
        this.updateClass();
    };
    /**
     * @return {?}
     */
    AsiNotification.prototype.getPosition = function () {
        return this._config.position;
    };
    /**
     * @return {?}
     */
    AsiNotification.prototype.updateClass = function () {
        this.renderer.addClass(this.element.nativeElement, this._config.position.toString());
        this.renderer.addClass(this.element.nativeElement, this._config.type.toString());
    };
    AsiNotification.decorators = [
        { type: Component, args: [{
                    selector: 'asi-notification',
                    template: "<div *ngIf=\"withIcon\" class=\"icon-container\"> <asi-fa-icon [icon]=\"icon\" size=\"lg\" [disabled]=\"true\"></asi-fa-icon> </div>",
                    host: { 'class': 'asi-component asi-notification' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiNotification.ctorParameters = function () { return [
        { type: ViewContainerRef, },
        { type: Renderer2, },
        { type: ElementRef, },
    ]; };
    return AsiNotification;
}());

var AsiNotificationContainer = (function () {
    /**
     * @param {?} viewContainerRef
     * @param {?} renderer
     * @param {?} element
     */
    function AsiNotificationContainer(viewContainerRef, renderer, element) {
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.element = element;
        this.subjectContainer = new Subject();
        this.notifications = [];
    }
    /**
     * @param {?} position
     * @return {?}
     */
    AsiNotificationContainer.prototype.setPosition = function (position) {
        this._position = position;
        this.updateClass();
    };
    /**
     * @return {?}
     */
    AsiNotificationContainer.prototype.getPosition = function () {
        return this._position;
    };
    /**
     * @return {?}
     */
    AsiNotificationContainer.prototype.updateClass = function () {
        this.renderer.addClass(this.element.nativeElement, this._position.toString());
    };
    /**
     * @return {?}
     */
    AsiNotificationContainer.prototype.onContainerEmpty = function () {
        return this.subjectContainer.asObservable();
    };
    /**
     * @param {?} componentRef
     * @param {?} config
     * @return {?}
     */
    AsiNotificationContainer.prototype.addNotification = function (componentRef, config) {
        var _this = this;
        this.notifications.unshift(componentRef);
        setTimeout(function () {
            _this.updatePosition();
        }, 5);
        if (config.delayInMs != null && config.delayInMs > 0) {
            setTimeout(function () {
                _this.removeNotification(componentRef);
            }, config.delayInMs);
        }
    };
    /**
     * @param {?} componentRef
     * @return {?}
     */
    AsiNotificationContainer.prototype.removeNotification = function (componentRef) {
        var _this = this;
        componentRef.location.nativeElement.style.opacity = "0";
        setTimeout(function () {
            remove(_this.notifications, function (notif) {
                return notif.instance == componentRef.instance;
            });
            _this.updatePosition();
            componentRef.destroy();
            if (_this.notifications.length == 0) {
                _this.subjectContainer.next(_this);
                _this.subjectContainer.complete();
            }
        }, 300);
    };
    /**
     * @return {?}
     */
    AsiNotificationContainer.prototype.updatePosition = function () {
        var /** @type {?} */ top = this._position.value.startsWith("top");
        var /** @type {?} */ position = 0;
        var /** @type {?} */ notifHeight;
        this.notifications.forEach(function (notification) {
            notifHeight = notification.location.nativeElement.offsetHeight;
            var /** @type {?} */ pos = (position * notifHeight + (5 * position)) + "px";
            if (top) {
                notification.location.nativeElement.style.top = pos;
            }
            else {
                notification.location.nativeElement.style.bottom = pos;
            }
            position++;
        });
    };
    AsiNotificationContainer.decorators = [
        { type: Component, args: [{
                    selector: 'asi-notification-container',
                    template: "<div class=\"asi-notification-container-panel\"></div>",
                    host: { 'class': 'asi-component asi-notification-container' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiNotificationContainer.ctorParameters = function () { return [
        { type: ViewContainerRef, },
        { type: Renderer2, },
        { type: ElementRef, },
    ]; };
    return AsiNotificationContainer;
}());

var AsiNotificationService = (function () {
    /**
     * @param {?} resolver
     * @param {?} appRef
     */
    function AsiNotificationService(resolver, appRef) {
        this.resolver = resolver;
        this.appRef = appRef;
        this.containerByPosition = new Map();
    }
    /**
     * @template T
     * @param {?} content
     * @param {?} config
     * @return {?}
     */
    AsiNotificationService.prototype.fromComponent = function (content, config) {
        var /** @type {?} */ containerRef = this.getContainerForPosition(config.position);
        var /** @type {?} */ notificationRef = this.createNotificiation(content, containerRef, config);
        containerRef.instance.addNotification(notificationRef, config);
        return notificationRef.instance;
    };
    /**
     * @param {?} position
     * @return {?}
     */
    AsiNotificationService.prototype.getContainerForPosition = function (position) {
        var _this = this;
        if (this.containerByPosition.get(position) == null) {
            //Récuperation du rootComponent
            var /** @type {?} */ rootComponent = this.appRef.components[0].instance;
            if (!rootComponent.viewContainerRef) {
                var /** @type {?} */ appName = this.appRef.componentTypes[0].name;
                throw new Error("AsiNotification : Please add 'viewContainerRef : ViewContainerRef' declaration in your root component constructor : " + appName);
            }
            //Création d'un AsiNotificationContainer
            var /** @type {?} */ asiNotificationContainerFactory = this.resolver.resolveComponentFactory(AsiNotificationContainer);
            var /** @type {?} */ containerRef = rootComponent.viewContainerRef.createComponent(asiNotificationContainerFactory, 0);
            containerRef.instance.setPosition(position);
            this.containerByPosition.set(position, containerRef);
            //Ecoute de la mise a vide du container pour le supprimer
            containerRef.instance.onContainerEmpty().subscribe(function (asiNotificationContainer) {
                var /** @type {?} */ containerRef = _this.containerByPosition.get(asiNotificationContainer.getPosition());
                _this.containerByPosition.delete(asiNotificationContainer.getPosition());
                containerRef.destroy();
            });
        }
        return this.containerByPosition.get(position);
    };
    /**
     * @template T
     * @param {?} content
     * @param {?} containerRef
     * @param {?} config
     * @return {?}
     */
    AsiNotificationService.prototype.createNotificiation = function (content, containerRef, config) {
        //Creation de la ntoficiation
        var /** @type {?} */ asiNotificationFactory = this.resolver.resolveComponentFactory(AsiNotification);
        var /** @type {?} */ asiNotificationRef = containerRef.instance.viewContainerRef.createComponent(asiNotificationFactory, 0);
        asiNotificationRef.instance.setConfig(config);
        //Deplacement de la notification dans la div notifications-container
        containerRef.location.nativeElement.children[0].appendChild(asiNotificationRef.location.nativeElement);
        //Création du composant désiré
        var /** @type {?} */ contentFactory = this.resolver.resolveComponentFactory(content);
        var /** @type {?} */ contentRef = asiNotificationRef.instance.viewContainerRef.createComponent(contentFactory);
        var /** @type {?} */ contentComponent = contentRef.instance;
        //Ajout de la reference du composant dans le AsiNotification
        asiNotificationRef.instance['_component'] = contentComponent;
        //Deplacement du contenu dans la div notification-panel
        asiNotificationRef.location.nativeElement.appendChild(contentRef.location.nativeElement);
        return asiNotificationRef;
    };
    AsiNotificationService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiNotificationService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
        { type: ApplicationRef, },
    ]; };
    return AsiNotificationService;
}());

var AsiNotificationModule = (function () {
    function AsiNotificationModule() {
    }
    /**
     * @return {?}
     */
    AsiNotificationModule.forRoot = function () {
        return {
            ngModule: AsiNotificationModule,
            providers: [AsiNotificationService]
        };
    };
    AsiNotificationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiNotificationContainer, AsiNotification],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiFaIconModule.forRoot()],
                    exports: [AsiNgToolsBaseModule],
                    entryComponents: [AsiNotificationContainer, AsiNotification],
                    providers: [AsiNotificationService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiNotificationModule.ctorParameters = function () { return []; };
    return AsiNotificationModule;
}());

var __extends$6 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiAutoCompleteComponent = (function (_super) {
    __extends$6(AsiAutoCompleteComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiAutoCompleteComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.delay = 500;
        _this.placeholder = "";
        _this.onRequestData = new EventEmitter();
        _this.autoCompleteControl = new FormControl();
        _this.open = false;
        //Marqueur permettant de gerer l'initialisation
        _this.firstRequestDone = null;
        _this.init = false;
        _this.currentValue = null;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        this.autoCompleteControl.valueChanges
            .debounceTime(this.delay)
            .subscribe(function (value) {
            _this.currentValue = value;
            _this.onRequestData.emit(value);
            _this.firstRequestDone = true;
        });
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.onDropdownClose = function () {
        this.open = false;
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.ngOnChanges = function () {
        if (this.init == true) {
            this.open = true;
        }
        else {
            if (this.firstRequestDone == true) {
                this.init = true;
            }
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.selectValue = function (data) {
        this.value = data;
        this.open = false;
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.clearValue = function () {
        var _this = this;
        this.value = null;
        this.autoCompleteControl.setValue(this.currentValue, { emitEvent: false });
        setTimeout(function () { _this.open = true; });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiAutoCompleteComponent.prototype.writeValue = function (value) {
        if (this.init == false) {
            this.autoCompleteControl.setValue(this.currentValue);
        }
        else {
            this._value = value;
            this.currentValue = value;
            if (this.value == null) {
                this.autoCompleteControl.setValue(this.currentValue, { emitEvent: false });
            }
        }
    };
    AsiAutoCompleteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-autocomplete',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"autocomplete\"> <input [attr.disabled]=\"disabled ? '' : null\" class=\"asi-focus-error\" [placeholder]=\"placeholder\" *ngIf=\"value == null\" [formControl]=\"autoCompleteControl\" /> <a tabindex=\"0\" class=\"clean-a autocomplete-header\" *ngIf=\"value != null\"> <div class=\"select-value\"> <ng-template [ngTemplateOutlet]=\"selected\" [ngOutletContext]=\"{data : value}\"></ng-template> </div> <button type=\"button\" [disabled]=\"disabled\" class=\"remove-icon-container\" (click)=\"clearValue()\"> <span class=\"remove-icon\" [innerHTML]=\"'&#10005;'\"></span> </button> </a> <asi-dropdown [open]=\"open\" (onClose)=\"onDropdownClose()\" #dropdown> <div class=\"drop-down-autocomplete\"> <div class=\"drop-down-panel\"> <button type=\"button\" class=\"drop-down-item\" (click)=\"selectValue(data)\" *ngFor=\"let data of datas\"> <div class=\"option\"> <span class=\"item\"> <ng-template *ngIf=\"data != null\" [ngTemplateOutlet]=\"option\" [ngOutletContext]=\"{data : data}\"></ng-template> </span> </div> </button> </div> </div> </asi-dropdown> </div>",
                    host: { 'class': 'asi-component asi-autocomplete' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiAutoCompleteComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiAutoCompleteComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiAutoCompleteComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'delay': [{ type: Input },],
        'datas': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'onRequestData': [{ type: Output },],
        'option': [{ type: ContentChild, args: ["option",] },],
        'selected': [{ type: ContentChild, args: ["selected",] },],
        'dropdown': [{ type: ViewChild, args: ["dropdown",] },],
    };
    return AsiAutoCompleteComponent;
}(DefaultControlValueAccessor));

var AsiAutoCompleteModule = (function () {
    function AsiAutoCompleteModule() {
    }
    /**
     * @return {?}
     */
    AsiAutoCompleteModule.forRoot = function () {
        return {
            ngModule: AsiAutoCompleteModule,
            providers: []
        };
    };
    AsiAutoCompleteModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiAutoCompleteComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiDropdownModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiAutoCompleteComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiAutoCompleteModule.ctorParameters = function () { return []; };
    return AsiAutoCompleteModule;
}());

var __extends$7 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiAutoCompleteMultipleComponent = (function (_super) {
    __extends$7(AsiAutoCompleteMultipleComponent, _super);
    /**
     * @param {?} renderer
     */
    function AsiAutoCompleteMultipleComponent(renderer) {
        var _this = _super.call(this) || this;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.placeholder = "";
        _this.delay = 500;
        _this.closeAfterSelect = false;
        _this.onRequestData = new EventEmitter();
        _this.autoCompleteControl = new FormControl();
        _this.open = false;
        //Marqueur permettant de gerer l'initialisation
        _this.firstRequestDone = null;
        _this.init = false;
        _this.currentValue = null;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.autoCompleteControl.valueChanges
            .debounceTime(this.delay)
            .subscribe(function (value) {
            _this.currentValue = value;
            _this.onRequestData.emit(value);
            _this.firstRequestDone = true;
        });
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.ngAfterViewInit = function () {
        this.renderer.addClass(this.container.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.onDropdownClose = function () {
        this.open = false;
    };
    /**
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.ngOnChanges = function () {
        if (this.init == true) {
            this.open = true;
        }
        else {
            if (this.firstRequestDone == true) {
                this.init = true;
            }
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.addValue = function (data) {
        if (this.value == null) {
            this.value = [];
        }
        this.value.push(data);
        if (this.closeAfterSelect) {
            this.open = false;
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.removeValue = function (data) {
        remove(this.value, function (value) {
            return data == value;
        });
        if (isEmpty(this.value)) {
            this.value = null;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiAutoCompleteMultipleComponent.prototype.writeValue = function (value) {
        this._value = value;
        if (this.init == false) {
            this.autoCompleteControl.setValue(this.currentValue);
        }
        else {
            this.currentValue = value;
            if (this.value == null) {
                this.autoCompleteControl.setValue(this.currentValue, { emitEvent: false });
            }
        }
    };
    AsiAutoCompleteMultipleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-autocomplete-multiple',
                    template: "<div class=\"tag-container\"> <div class=\"tag\" *ngFor=\"let aValue of value\"> <span> <ng-template [ngTemplateOutlet]=\"tag\" [ngOutletContext]=\"{data : aValue}\"></ng-template> </span> <button type=\"button\" [disabled]=\"disabled\" class=\"remove-icon-container\" (click)=\"removeValue(aValue)\"> <span class=\"remove-icon\" [innerHTML]=\"'&#10005;'\"></span> </button> </div> </div> <div class=\"autocomplete-container\" #container> <label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"autocomplete\"> <input [attr.disabled]=\"disabled ? '' : null\" class=\"asi-focus-error\" [placeholder]=\"placeholder\" [formControl]=\"autoCompleteControl\" /> <asi-dropdown [open]=\"open\" (onClose)=\"onDropdownClose()\" #dropdown> <div class=\"drop-down-autocomplete-multiple\"> <div class=\"drop-down-panel\" [ngClass]=\"{'open' : open }\"> <button type=\"button\" class=\"drop-down-item\" (click)=\"addValue(data)\" *ngFor=\"let data of datas\"> <div class=\"option\"> <span class=\"item\"> <ng-template *ngIf=\"data != null\" [ngTemplateOutlet]=\"option\" [ngOutletContext]=\"{data : data}\"></ng-template> </span> </div> </button> </div> </div> </asi-dropdown> </div> </div>",
                    host: { 'class': 'asi-component asi-autocomplete-multiple' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiAutoCompleteMultipleComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiAutoCompleteMultipleComponent.ctorParameters = function () { return [
        { type: Renderer2, },
    ]; };
    AsiAutoCompleteMultipleComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'delay': [{ type: Input },],
        'datas': [{ type: Input },],
        'closeAfterSelect': [{ type: Input },],
        'onRequestData': [{ type: Output },],
        'option': [{ type: ContentChild, args: ["option",] },],
        'tag': [{ type: ContentChild, args: ["tag",] },],
        'container': [{ type: ViewChild, args: ["container",] },],
    };
    return AsiAutoCompleteMultipleComponent;
}(DefaultControlValueAccessor));

var AsiAutoCompleteMultipleModule = (function () {
    function AsiAutoCompleteMultipleModule() {
    }
    /**
     * @return {?}
     */
    AsiAutoCompleteMultipleModule.forRoot = function () {
        return {
            ngModule: AsiAutoCompleteMultipleModule,
            providers: []
        };
    };
    AsiAutoCompleteMultipleModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiAutoCompleteMultipleComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiDropdownModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiAutoCompleteMultipleComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiAutoCompleteMultipleModule.ctorParameters = function () { return []; };
    return AsiAutoCompleteMultipleModule;
}());

var AsiBindHtml = (function () {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     * @param {?} fileService
     */
    function AsiBindHtml(renderer, elementRef, fileService) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.fileService = fileService;
    }
    /**
     * @return {?}
     */
    AsiBindHtml.prototype.ngOnChanges = function () {
        this.initContent();
    };
    /**
     * @return {?}
     */
    AsiBindHtml.prototype.initContent = function () {
        var _this = this;
        if (this.fromUrl != null) {
            this.fileService.getFileAsText(this.fromUrl).subscribe(function (result) {
                _this.value = result;
                _this.renderer.setElementProperty(_this.elementRef.nativeElement, 'innerHTML', _this.value);
            });
        }
        else {
            this.renderer.setElementProperty(this.elementRef.nativeElement, 'innerHTML', this.value);
        }
    };
    AsiBindHtml.decorators = [
        { type: Component, args: [{
                    selector: 'asi-bind-html',
                    template: '<div><div>',
                    host: { 'class': 'asi-component asi-bind-html' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiBindHtml.ctorParameters = function () { return [
        { type: Renderer, },
        { type: ElementRef, },
        { type: AsiFileService, },
    ]; };
    AsiBindHtml.propDecorators = {
        'value': [{ type: Input },],
        'fromUrl': [{ type: Input },],
    };
    return AsiBindHtml;
}());

var AsiBindHtmlModule = (function () {
    function AsiBindHtmlModule() {
    }
    /**
     * @return {?}
     */
    AsiBindHtmlModule.forRoot = function () {
        return {
            ngModule: AsiBindHtmlModule,
            providers: [AsiFileService]
        };
    };
    AsiBindHtmlModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiBindHtml],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiBindHtml],
                    entryComponents: [],
                    providers: [AsiFileService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiBindHtmlModule.ctorParameters = function () { return []; };
    return AsiBindHtmlModule;
}());

var AsiCodeViewer = (function () {
    /**
     * @param {?} fileService
     */
    function AsiCodeViewer(fileService) {
        this.fileService = fileService;
        this.language = 'typescript';
    }
    /**
     * @return {?}
     */
    AsiCodeViewer.prototype.ngOnInit = function () {
        var _this = this;
        if (this.fromUrl != null) {
            this.fileService.getFileAsText(this.fromUrl).subscribe(function (result) {
                _this.value = result;
                if (_this.value != null) {
                    _this.hightlightCode = Prism.highlight(_this.value, Prism.languages[_this.language]);
                }
            });
        }
        else if (this.value != null) {
            this.hightlightCode = Prism.highlight(this.value, Prism.languages[this.language]);
        }
    };
    /**
     * @param {?} change
     * @return {?}
     */
    AsiCodeViewer.prototype.ngOnChanges = function (change) {
        var _this = this;
        if (change.value != null && change.value.currentValue != null) {
            this.hightlightCode = Prism.highlight(change.value.currentValue, Prism.languages[this.language]);
        }
        else if (change.fromUrl != null) {
            this.fileService.getFileAsText(change.fromUrl.currentValue).subscribe(function (result) {
                _this.value = result;
                if (_this.value != null) {
                    _this.hightlightCode = Prism.highlight(_this.value, Prism.languages[_this.language]);
                }
            });
        }
    };
    AsiCodeViewer.decorators = [
        { type: Component, args: [{
                    selector: 'asi-code-viewer',
                    template: "<pre [ngClass]=\"'language-' + language\" [innerHTML]=\"hightlightCode\"></pre>",
                    host: { 'class': 'asi-component asi-code-viewer' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCodeViewer.ctorParameters = function () { return [
        { type: AsiFileService, },
    ]; };
    AsiCodeViewer.propDecorators = {
        'language': [{ type: Input },],
        'fromUrl': [{ type: Input },],
        'value': [{ type: Input },],
    };
    return AsiCodeViewer;
}());

var AsiCodeViewerModule = (function () {
    function AsiCodeViewerModule() {
    }
    /**
     * @return {?}
     */
    AsiCodeViewerModule.forRoot = function () {
        return {
            ngModule: AsiCodeViewerModule,
            providers: []
        };
    };
    AsiCodeViewerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiCodeViewer],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiCodeViewer],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCodeViewerModule.ctorParameters = function () { return []; };
    return AsiCodeViewerModule;
}());

var AsiCollapseHeader = (function () {
    function AsiCollapseHeader() {
    }
    AsiCollapseHeader.decorators = [
        { type: Component, args: [{
                    selector: 'asi-collapse-header',
                    template: '<ng-template><ng-content></ng-content></ng-template>'
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCollapseHeader.ctorParameters = function () { return []; };
    AsiCollapseHeader.propDecorators = {
        'template': [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return AsiCollapseHeader;
}());

var AsiCollapseComponent = (function () {
    function AsiCollapseComponent() {
        this.collapse = false;
        this.disabled = false;
        this.state = "collapsed";
    }
    /**
     * @return {?}
     */
    AsiCollapseComponent.prototype.toggleCollapse = function () {
        this.collapse = !this.collapse;
        this.state = (this.collapse) ? "collapsed" : "notcollapsed";
    };
    AsiCollapseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-collapse',
                    template: "<button type=\"button\" class=\"collapse-header\" [disabled]=\"disabled\" (click)=\"toggleCollapse()\"> <span *ngIf=\"header == null\"> {{label | translate }} </span> <ng-template *ngIf=\"header != null\" [ngTemplateOutlet]=\"header.template\"></ng-template> </button> <div class=\"collapse-panel\" *ngIf=\"!collapse\" [@reveal]> <ng-content></ng-content> </div>",
                    host: { 'class': 'asi-component asi-collapse' },
                    animations: [
                        trigger('reveal', [
                            transition('void => *', [
                                style({ height: 0 }),
                                animate('500ms ease-in-out', style({ height: '*' }))
                            ]),
                            transition('* => void', [
                                animate('500ms ease-in-out', style({ height: 0 }))
                            ])
                        ])
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCollapseComponent.ctorParameters = function () { return []; };
    AsiCollapseComponent.propDecorators = {
        'label': [{ type: Input },],
        'collapse': [{ type: Input },],
        'disabled': [{ type: Input },],
        'header': [{ type: ContentChild, args: [AsiCollapseHeader,] },],
    };
    return AsiCollapseComponent;
}());

var AsiCollapseModule = (function () {
    function AsiCollapseModule() {
    }
    /**
     * @return {?}
     */
    AsiCollapseModule.forRoot = function () {
        return {
            ngModule: AsiCollapseModule,
            providers: []
        };
    };
    AsiCollapseModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiCollapseComponent, AsiCollapseHeader],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiCollapseComponent, AsiCollapseHeader],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCollapseModule.ctorParameters = function () { return []; };
    return AsiCollapseModule;
}());

var DayItem = (function () {
    /**
     * @param {?} num
     * @param {?} month
     * @param {?} year
     * @param {?} date
     * @param {?} aClass
     */
    function DayItem(num, month, year, date, aClass) {
        this.day = num;
        this.month = month;
        this.year = year;
        this.date = date;
        this.class = aClass;
    }
    return DayItem;
}());
var /** @type {?} */ months_fr$1 = [
    { num: 1, libelle: "Janvier" },
    { num: 2, libelle: "Février" },
    { num: 3, libelle: "Mars" },
    { num: 4, libelle: "Avril" },
    { num: 5, libelle: "Mai" },
    { num: 6, libelle: "Juin" },
    { num: 7, libelle: "Juillet" },
    { num: 8, libelle: "Août" },
    { num: 9, libelle: "Septembre" },
    { num: 10, libelle: "Octobre" },
    { num: 11, libelle: "Novembre" },
    { num: 12, libelle: "Décembre" },
];
var /** @type {?} */ months_en$1 = [
    { num: 1, libelle: "January" },
    { num: 2, libelle: "February" },
    { num: 3, libelle: "March" },
    { num: 4, libelle: "April" },
    { num: 5, libelle: "May" },
    { num: 6, libelle: "June" },
    { num: 7, libelle: "July" },
    { num: 8, libelle: "August" },
    { num: 9, libelle: "September" },
    { num: 10, libelle: "October" },
    { num: 11, libelle: "November" },
    { num: 12, libelle: "Decemder" }
];
var /** @type {?} */ days_fr = [
    { num: 1, libelle: "L" },
    { num: 2, libelle: "M" },
    { num: 3, libelle: "M" },
    { num: 4, libelle: "J" },
    { num: 5, libelle: "V" },
    { num: 6, libelle: "S" },
    { num: 7, libelle: "D" },
];
var /** @type {?} */ days_en = [
    { num: 1, libelle: "M" },
    { num: 2, libelle: "T" },
    { num: 3, libelle: "W" },
    { num: 4, libelle: "T" },
    { num: 5, libelle: "F" },
    { num: 6, libelle: "S" },
    { num: 7, libelle: "S" },
];

var __extends$8 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiCalendarComponent = (function (_super) {
    __extends$8(AsiCalendarComponent, _super);
    function AsiCalendarComponent() {
        var _this = _super.call(this) || this;
        _this.onDatePicked = new EventEmitter();
        _this.open = false;
        if (_this.isFr()) {
            _this.days = days_fr;
            _this.months = months_fr$1;
        }
        else {
            _this.days = days_en;
            _this.months = months_en$1;
        }
        _this.initYears();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.isFr = function () {
        return navigator.language == "fr" || navigator.language == "fr-FR";
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.ngOnChanges = function () {
        if (this.minDate) {
            this.minDate.setHours(0, 0, 0, 0);
        }
        if (this.maxDate) {
            this.maxDate.setHours(23, 59, 59, 999);
        }
        this.calculDays();
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.initYears = function () {
        var /** @type {?} */ results = new Array();
        var /** @type {?} */ currentYear = new Date().getFullYear() + 1;
        for (var /** @type {?} */ year = currentYear; year >= 1900; year--) {
            results.push(year);
        }
        this.years = results;
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.onDropdownClose = function () {
        this.open = false;
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.openCalendar = function () {
        this.open = true;
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.closeCalendar = function () {
        this.open = false;
    };
    /**
     * @param {?} dayItem
     * @return {?}
     */
    AsiCalendarComponent.prototype.onDaySelected = function (dayItem) {
        this.selectedDay = new DayItem(dayItem.day, dayItem.month, dayItem.year, dayItem.date, 'selected enabled');
        this.value = dayItem.date;
        this.closeCalendar();
        this.calculDays();
        this.onDatePicked.emit(this.value);
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.onMonthSelected = function () {
        var /** @type {?} */ date = new Date(this.selectedYear, this.selectedMonth.num - 1, this.selectedDay.day);
        this.value = date;
        this.calculDays();
        this.onDatePicked.emit(date);
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.onYearSelected = function () {
        var /** @type {?} */ date = new Date(this.selectedYear, this.selectedMonth.num - 1, this.selectedDay.day);
        this.value = date;
        this.calculDays();
        this.onDatePicked.emit(date);
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.calculDays = function () {
        if (!this.selectedMonth || !this.selectedYear) {
            return;
        }
        var /** @type {?} */ month = this.selectedMonth.num - 1;
        var /** @type {?} */ year = this.selectedYear;
        var /** @type {?} */ result = [];
        var /** @type {?} */ date = new Date(year, month, 1);
        var /** @type {?} */ mondayDelta = 0;
        var /** @type {?} */ day = date.getDay();
        if (day == 0) {
            mondayDelta = -6;
        }
        else {
            mondayDelta = -(day - 1);
        }
        date = moment(date).add(mondayDelta, "days").toDate();
        var /** @type {?} */ deltaMonth = date.getMonth();
        if (deltaMonth != month) {
            //Before first day of the month
            while (date.getMonth() == deltaMonth) {
                if (date.getDate() == this.selectedDay.day
                    && date.getMonth() + 1 == this.selectedDay.month
                    && date.getFullYear() == this.selectedDay.year) {
                    result.push(this.selectedDay);
                }
                else {
                    result.push(new DayItem(date.getDate(), date.getMonth() + 1, date.getFullYear(), new Date(date), 'extra enabled'));
                }
                date.setDate(date.getDate() + 1);
            }
        }
        //Month dates
        while (date.getMonth() == month) {
            if (date.getDate() == this.selectedDay.day
                && date.getMonth() + 1 == this.selectedDay.month
                && date.getFullYear() == this.selectedDay.year) {
                result.push(this.selectedDay);
            }
            else {
                result.push(new DayItem(date.getDate(), date.getMonth() + 1, date.getFullYear(), new Date(date), 'enabled'));
            }
            date.setDate(date.getDate() + 1);
        }
        //Days of the last week
        while (date.getDay() != 1) {
            if (date.getDate() == this.selectedDay.day
                && date.getMonth() + 1 == this.selectedDay.month
                && date.getFullYear() == this.selectedDay.year) {
                result.push(this.selectedDay);
            }
            else {
                result.push(new DayItem(date.getDate(), date.getMonth() + 1, date.getFullYear(), new Date(date), 'extra enabled'));
            }
            date.setDate(date.getDate() + 1);
        }
        this.dayOfMonths = result;
        this.manageMinAndMaxDate();
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.manageMinAndMaxDate = function () {
        var _this = this;
        if (this.dayOfMonths) {
            forEach(this.dayOfMonths, function (dayItem) {
                if (_this.minDate != null) {
                    if (dayItem.date < _this.minDate) {
                        dayItem.class = "disabled";
                    }
                }
                if (_this.maxDate != null) {
                    if (dayItem.date > _this.maxDate) {
                        dayItem.class = "disabled";
                    }
                }
            });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiCalendarComponent.prototype.writeValue = function (value) {
        this._value = value;
        this.initToDate(value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiCalendarComponent.prototype.initToDate = function (value) {
        if (value == null) {
            value = new Date();
        }
        this.selectedYear = value.getFullYear();
        var /** @type {?} */ dateMonth = value.getMonth() + 1;
        this.selectedMonth = find(this.months, function (month) {
            return month.num == dateMonth;
        });
        this.selectedDay = new DayItem(value.getDate(), this.selectedMonth.num, this.selectedYear, new Date(value), 'selected enabled');
        this.calculDays();
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.goNextMonth = function () {
        var /** @type {?} */ nextMonthNum = this.selectedMonth.num + 1;
        if (nextMonthNum == 13) {
            nextMonthNum = 1;
            this.selectedYear = this.selectedYear + 1;
            if (this.years.indexOf(this.selectedYear) == -1) {
                this.years.push(this.selectedYear);
            }
        }
        this.selectedMonth = find(this.months, function (month) {
            return month.num == nextMonthNum;
        });
        this.calculDays();
    };
    /**
     * @return {?}
     */
    AsiCalendarComponent.prototype.goPreviousMonth = function () {
        var /** @type {?} */ nextMonthNum = this.selectedMonth.num - 1;
        if (nextMonthNum == 0) {
            nextMonthNum = 12;
            this.selectedYear = this.selectedYear - 1;
        }
        this.selectedMonth = find(this.months, function (month) {
            return month.num == nextMonthNum;
        });
        this.calculDays();
    };
    AsiCalendarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-calendar',
                    template: "<asi-fa-icon [disabled]=\"disabled\" icon=\"fa-calendar\" (onClick)=\"open = !open\"></asi-fa-icon> <asi-dropdown [open]=\"open\" [relativeTo]=\"relativeTo\" (onClose)=\"onDropdownClose()\" [calculWidth]=\"false\"> <div class=\"asi-calendar-picker\"> <div class=\"calendar-header\"> <asi-fa-icon icon=\"fa-angle-left\" size=\"lg\" (onClick)=\"goPreviousMonth()\"></asi-fa-icon> <asi-select class=\"select-month\" [disabled]=\"disabled\" [(ngModel)]=\"selectedMonth\" [datas]=\"months\" (onValueChange)=\"calculDays()\"> <ng-template #selected let-data=\"data\">{{data.num + \" - \" + data.libelle}}</ng-template> <ng-template #option let-data=\"data\">{{data.num + \" - \" + data.libelle}}</ng-template> </asi-select> <asi-select class=\"select-year\" [disabled]=\"disabled\" [(ngModel)]=\"selectedYear\" [datas]=\"years\" (onValueChange)=\"calculDays()\"> <ng-template #selected let-data=\"data\">{{data}}</ng-template> <ng-template #option let-data=\"data\">{{data}}</ng-template> </asi-select> <asi-fa-icon icon=\"fa-angle-right\" size=\"lg\" (onClick)=\"goNextMonth()\"></asi-fa-icon> </div> <div class=\"day-list\"> <div class=\"day-str\" *ngFor=\"let day of days\"> <span>{{day.libelle}}</span> </div> </div> <div class=\"calendar-panel\" mouseWheel (mouseWheelUp)=\"goPreviousMonth()\" (mouseWheelDown)=\"goNextMonth()\"> <button [attr.disabled]=\"day.class === 'disabled' ? true : null\" class=\"day-item\" *ngFor=\"let day of dayOfMonths\" [ngClass]=\"day.class\" (click)=\"onDaySelected(day)\"> <span>{{day.day}}</span> </button> </div> </div> </asi-dropdown>",
                    host: { 'class': 'asi-component asi-calendar' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiCalendarComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCalendarComponent.ctorParameters = function () { return []; };
    AsiCalendarComponent.propDecorators = {
        'relativeTo': [{ type: Input },],
        'minDate': [{ type: Input },],
        'maxDate': [{ type: Input },],
        'onDatePicked': [{ type: Output },],
    };
    return AsiCalendarComponent;
}(DefaultControlValueAccessor));

var AsiCalendarModule = (function () {
    function AsiCalendarModule() {
    }
    /**
     * @return {?}
     */
    AsiCalendarModule.forRoot = function () {
        return {
            ngModule: AsiCalendarModule,
            providers: []
        };
    };
    AsiCalendarModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiCalendarComponent],
                    imports: [AsiNgToolsBaseModule, AsiDirectivesModule.forRoot(), AsiSelectModule.forRoot(), AsiFaIconModule.forRoot(), AsiDropdownModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiCalendarComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiCalendarModule.ctorParameters = function () { return []; };
    return AsiCalendarModule;
}());

var __extends$9 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiDatePickerComponent = (function (_super) {
    __extends$9(AsiDatePickerComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiDatePickerComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.placeholder = "";
        _this.labelPosition = "top";
        _this.pattern = "DD/MM/YYYY";
        _this.autoOpen = true;
        _this.inputControl = new FormControl();
        _this.dateValid = true;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiDatePickerComponent.prototype.ngOnInit = function () {
        this.placeholder = this.pattern.toLowerCase();
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiDatePickerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.inputControl.valueChanges.subscribe(function (val) {
            _this.dateValid = true;
            if (val == "" || val == null) {
                _this.value = null;
            }
            else {
                var /** @type {?} */ momentTest = moment(val, _this.pattern);
                if (momentTest.isValid()) {
                    if (val.length == _this.pattern.length) {
                        _this.value = momentTest.toDate();
                    }
                    else {
                        _this.value = null;
                    }
                }
                else {
                    _this.value = null;
                    _this.dateValid = false;
                }
            }
        });
    };
    /**
     * @return {?}
     */
    AsiDatePickerComponent.prototype.openCalendar = function () {
        if (this.autoOpen) {
            this.calendarElement.openCalendar();
        }
    };
    /**
     * @param {?} date
     * @return {?}
     */
    AsiDatePickerComponent.prototype.onDatePicked = function (date) {
        var /** @type {?} */ formattedValue = moment(date).format(this.pattern);
        this.inputControl.setValue(formattedValue);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiDatePickerComponent.prototype.writeValue = function (value) {
        if (value != null) {
            var /** @type {?} */ momentValue = moment(value);
            this._value = momentValue.toDate();
            var /** @type {?} */ formattedValue = momentValue.format(this.pattern);
            this.inputControl.setValue(formattedValue, { emitEvent: false });
        }
        else {
            this._value = value;
            this.inputControl.setValue(null, { emitEvent: false });
        }
    };
    AsiDatePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-datepicker',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"asi-datepicker-container\"> <input #input [attr.disabled]=\"disabled ? '' : null\" class=\"asi-focus-error\" [placeholder]=\"placeholder\" (click)=\"openCalendar()\" [formControl]=\"inputControl\"/> <asi-calendar #calendar [relativeTo]=\"inputElement\" [(ngModel)]=\"value\" [minDate]=\"minDate\" [maxDate]=\"maxDate\" (onDatePicked)=\"onDatePicked($event)\"></asi-calendar> </div>",
                    host: { 'class': 'asi-component asi-datepicker' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiDatePickerComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDatePickerComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiDatePickerComponent.propDecorators = {
        'label': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'pattern': [{ type: Input },],
        'minDate': [{ type: Input },],
        'maxDate': [{ type: Input },],
        'autoOpen': [{ type: Input },],
        'inputElement': [{ type: ViewChild, args: ["input",] },],
        'calendarElement': [{ type: ViewChild, args: ["calendar",] },],
    };
    return AsiDatePickerComponent;
}(DefaultControlValueAccessor));

var AsiDatePickerModule = (function () {
    function AsiDatePickerModule() {
    }
    /**
     * @return {?}
     */
    AsiDatePickerModule.forRoot = function () {
        return {
            ngModule: AsiDatePickerModule,
            providers: []
        };
    };
    AsiDatePickerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiDatePickerComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiCalendarModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiDatePickerComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDatePickerModule.ctorParameters = function () { return []; };
    return AsiDatePickerModule;
}());

var AsiDialog = (function () {
    /**
     * @param {?} viewContainerRef
     */
    function AsiDialog(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this._dialogDestroy = new Subject();
        this.dialogClose = new Subject();
        this.dialogCancel = new Subject();
    }
    /**
     * @return {?}
     */
    AsiDialog.prototype.getComponent = function () {
        return this._component;
    };
    /**
     * @param {?} config
     * @return {?}
     */
    AsiDialog.prototype.setConfig = function (config) {
        this._config = config;
    };
    /**
     * @param {?=} param
     * @return {?}
     */
    AsiDialog.prototype.close = function (param) {
        this.dialogClose.next(param);
        this.dialogClose.complete();
        this._dialogDestroy.next();
        this._dialogDestroy.complete();
    };
    /**
     * @param {?=} param
     * @return {?}
     */
    AsiDialog.prototype.cancel = function (param) {
        this.dialogCancel.next(param);
        this.dialogCancel.complete();
        this._dialogDestroy.next();
        this._dialogDestroy.complete();
    };
    /**
     * @return {?}
     */
    AsiDialog.prototype.onDialogCancel = function () {
        return this.dialogCancel.asObservable();
    };
    /**
     * @return {?}
     */
    AsiDialog.prototype.onDialogClose = function () {
        return this.dialogClose.asObservable();
    };
    AsiDialog.decorators = [
        { type: Component, args: [{
                    selector: 'asi-dialog',
                    template: "<div class=\"dialog-panel\"> </div>",
                    host: { 'class': 'asi-component asi-dialog' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDialog.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    return AsiDialog;
}());

var AsiDialogContainer = (function () {
    /**
     * @param {?} viewContainerRef
     */
    function AsiDialogContainer(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.dialogs = [];
        this.subjectContainer = new Subject();
    }
    /**
     * @return {?}
     */
    AsiDialogContainer.prototype.onContainerEmpty = function () {
        return this.subjectContainer.asObservable();
    };
    /**
     * @param {?} dialogRef
     * @param {?=} config
     * @return {?}
     */
    AsiDialogContainer.prototype.addDialog = function (dialogRef, config) {
        var _this = this;
        //pour passer la verif en attendant des updates du dialog
        config = null;
        this.dialogs.push(dialogRef);
        dialogRef.instance["_dialogDestroy"].subscribe(function () {
            _this.removeDialog(dialogRef);
        });
        setTimeout(function () {
            if (_this.visibleDialog) {
                _this.visibleDialog.location.nativeElement.style.display = "none";
            }
            _this.visibleDialog = dialogRef;
            _this.visibleDialog.location.nativeElement.style.display = "block";
        }, 200);
    };
    /**
     * @param {?} dialogRef
     * @return {?}
     */
    AsiDialogContainer.prototype.removeDialog = function (dialogRef) {
        var _this = this;
        remove(this.dialogs, function (dialog) {
            return dialog.instance == dialogRef.instance;
        });
        dialogRef.destroy();
        if (this.dialogs.length == 0) {
            this.shadow.nativeElement.style.opacity = "0";
            setTimeout(function () {
                _this.subjectContainer.next(_this);
                _this.subjectContainer.complete();
            }, 200);
        }
        else {
            this.visibleDialog = this.dialogs[this.dialogs.length - 1];
            this.visibleDialog.location.nativeElement.style.display = "block";
        }
    };
    /**
     * @return {?}
     */
    AsiDialogContainer.prototype.ngAfterContentInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.shadow.nativeElement.style.opacity = "0.5";
        }, 50);
    };
    AsiDialogContainer.decorators = [
        { type: Component, args: [{
                    selector: 'asi-dialog-container',
                    template: "<div class=\"dialog-container\"> <div #shadow class=\"dialog-backdrop\"></div> </div>",
                    host: { 'class': 'asi-component asi-dialog-container' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDialogContainer.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    AsiDialogContainer.propDecorators = {
        'shadow': [{ type: ViewChild, args: ["shadow",] },],
    };
    return AsiDialogContainer;
}());

var AsiDialogService = (function () {
    /**
     * @param {?} resolver
     * @param {?} appRef
     */
    function AsiDialogService(resolver, appRef) {
        this.resolver = resolver;
        this.appRef = appRef;
    }
    /**
     * @template T
     * @param {?} content
     * @param {?} config
     * @return {?}
     */
    AsiDialogService.prototype.fromComponent = function (content, config) {
        var _this = this;
        var /** @type {?} */ containerRef = this.getContainer();
        containerRef.instance.onContainerEmpty().subscribe(function () {
            _this.dialogContainer.destroy();
            _this.dialogContainer = null;
        });
        var /** @type {?} */ dialogRef = this.createDialog(content, containerRef, config);
        containerRef.instance.addDialog(dialogRef, config);
        return dialogRef.instance;
    };
    /**
     * @return {?}
     */
    AsiDialogService.prototype.getContainer = function () {
        if (this.dialogContainer == null) {
            //Récuperation du rootComponent
            var /** @type {?} */ rootComponent = this.appRef.components[0].instance;
            if (!rootComponent.viewContainerRef) {
                var /** @type {?} */ appName = this.appRef.componentTypes[0].name;
                throw new Error("AsiDialog : Please add 'viewContainerRef : ViewContainerRef' declaration in your root component constructor : " + appName);
            }
            //Création d'un AsiDialogContainer
            var /** @type {?} */ asiDialogContainerFactory = this.resolver.resolveComponentFactory(AsiDialogContainer);
            var /** @type {?} */ containerRef = rootComponent.viewContainerRef.createComponent(asiDialogContainerFactory, 0);
            this.dialogContainer = containerRef;
        }
        return this.dialogContainer;
    };
    /**
     * @template T
     * @param {?} content
     * @param {?} containerRef
     * @param {?} config
     * @return {?}
     */
    AsiDialogService.prototype.createDialog = function (content, containerRef, config) {
        //Creation de la notification
        var /** @type {?} */ asiDialogFactory = this.resolver.resolveComponentFactory(AsiDialog);
        var /** @type {?} */ asiDialogRef = containerRef.instance.viewContainerRef.createComponent(asiDialogFactory, 0);
        asiDialogRef.instance.setConfig(config);
        //Deplacement de la dialog dans la div dialog-container
        containerRef.location.nativeElement.children[0].appendChild(asiDialogRef.location.nativeElement);
        //Création du composant désiré
        var /** @type {?} */ contentFactory = this.resolver.resolveComponentFactory(content);
        var /** @type {?} */ contentRef = asiDialogRef.instance.viewContainerRef.createComponent(contentFactory);
        var /** @type {?} */ contentComponent = contentRef.instance;
        //Ajout de la reference du composant dans le AsiDialog
        asiDialogRef.instance['_component'] = contentComponent;
        contentComponent.registerDialog(asiDialogRef.instance);
        //Deplacement du contenu dans la div dialog-panel
        asiDialogRef.location.nativeElement.children[0].appendChild(contentRef.location.nativeElement);
        return asiDialogRef;
    };
    AsiDialogService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AsiDialogService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
        { type: ApplicationRef, },
    ]; };
    return AsiDialogService;
}());

/**
 * Class de configuration
 */
var AsiDialogConfig = (function () {
    function AsiDialogConfig() {
    }
    return AsiDialogConfig;
}());

var AsiDialogView = (function () {
    function AsiDialogView() {
    }
    /**
     * @param {?} asiDialog
     * @return {?}
     */
    AsiDialogView.prototype.registerDialog = function (asiDialog) {
        this.dialog = asiDialog;
    };
    return AsiDialogView;
}());

var AsiDialogModule = (function () {
    function AsiDialogModule() {
    }
    /**
     * @return {?}
     */
    AsiDialogModule.forRoot = function () {
        return {
            ngModule: AsiDialogModule,
            providers: [AsiDialogService]
        };
    };
    AsiDialogModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiDialogContainer, AsiDialog],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule],
                    entryComponents: [AsiDialogContainer, AsiDialog],
                    providers: [AsiDialogService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiDialogModule.ctorParameters = function () { return []; };
    return AsiDialogModule;
}());

var __extends$a = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Composant permettant la selection d'une image
Exemple d'utilisation :
<asi-image-chooser (onImageSelected)="imageSelect($event)" formControlName="logo" (onError)="imageError($event)"></asi-image-chooser>
 */
var AsiImageChooserComponent = (function (_super) {
    __extends$a(AsiImageChooserComponent, _super);
    /**
     * @param {?} fileService
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiImageChooserComponent(fileService, elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.fileService = fileService;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.icon = "fa-picture-o";
        _this.onImageSelected = new EventEmitter();
        _this.onError = new EventEmitter();
        _this.dragging = false;
        _this.loaded = false;
        _this.imageLoaded = false;
        _this.init = false;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiImageChooserComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        if (this.imageSrc != null) {
            this.fileService.getBlobImage(this.imageSrc).subscribe(function (blob) {
                _this.fileService.blobToBase64(blob).subscribe(function (base64) {
                    _this.image64 = base64;
                });
                var /** @type {?} */ imageName = _this.imageSrc.split('/').pop();
                _this.value = new Blob([blob], { type: blob.type });
                _this.value.name = imageName;
                _this.init = true;
            });
        }
        else {
            this.init = true;
        }
    };
    /**
     * @return {?}
     */
    AsiImageChooserComponent.prototype.openFileInput = function () {
        this.fileInput.nativeElement.click();
    };
    /**
     * @return {?}
     */
    AsiImageChooserComponent.prototype.handleDragEnter = function () {
        this.dragging = true;
    };
    /**
     * @return {?}
     */
    AsiImageChooserComponent.prototype.handleDragLeave = function () {
        this.dragging = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AsiImageChooserComponent.prototype.handleDrop = function (e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    };
    /**
     * @return {?}
     */
    AsiImageChooserComponent.prototype.handleImageLoad = function () {
        this.imageLoaded = true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AsiImageChooserComponent.prototype.handleInputChange = function (event) {
        var /** @type {?} */ imageFile = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];
        var /** @type {?} */ pattern = /image-*/;
        var /** @type {?} */ reader = new FileReader();
        if (!imageFile.type.match(pattern)) {
            this.onError.emit({
                error: "FORMAT",
                file: imageFile
            });
            return;
        }
        this.loaded = false;
        this.imageFile = imageFile;
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(imageFile);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AsiImageChooserComponent.prototype._handleReaderLoaded = function (event) {
        var /** @type {?} */ reader = event.target;
        this.image64 = reader.result;
        this.onImageSelected.emit(this.imageFile);
        this.loaded = true;
        this.value = this.imageFile;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiImageChooserComponent.prototype.writeValue = function (value) {
        this._value = value;
        if (value == null && this.init) {
            this.imageSrc = null;
            this.image64 = null;
        }
    };
    AsiImageChooserComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-image-chooser',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <label class=\"asi-image-chooser-container\" ondragover=\"return false;\" [class.loaded]=\"loaded\" (dragenter)=\"handleDragEnter()\" (dragleave)=\"handleDragLeave()\" (drop)=\"handleDrop($event)\"> <img *ngIf=\"image64 != null\" [src]=\"image64\" (load)=\"handleImageLoad()\" [class.loaded]=\"imageLoaded\" /> <input #fileInput type=\"file\" [disabled]=\"disabled\" name=\"file\" accept=\"image/*\" (change)=\"handleInputChange($event)\"> <asi-fa-icon *ngIf=\"image64 == null\" (onClick)=\"openFileInput()\" class=\"asi-focus-error\" [icon]=\"icon\" size=\"2x\"></asi-fa-icon> </label>",
                    host: { 'class': 'asi-component asi-image-chooser' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiImageChooserComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiImageChooserComponent.ctorParameters = function () { return [
        { type: AsiFileService, },
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiImageChooserComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'imageSrc': [{ type: Input },],
        'image64': [{ type: Input },],
        'icon': [{ type: Input },],
        'onImageSelected': [{ type: Output },],
        'onError': [{ type: Output },],
        'fileInput': [{ type: ViewChild, args: ["fileInput",] },],
    };
    return AsiImageChooserComponent;
}(DefaultControlValueAccessor));

var AsiImageChooserModule = (function () {
    function AsiImageChooserModule() {
    }
    /**
     * @return {?}
     */
    AsiImageChooserModule.forRoot = function () {
        return {
            ngModule: AsiImageChooserModule,
            providers: [AsiFileService]
        };
    };
    AsiImageChooserModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiImageChooserComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiFaIconModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiImageChooserComponent],
                    entryComponents: [],
                    providers: [AsiFileService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiImageChooserModule.ctorParameters = function () { return []; };
    return AsiImageChooserModule;
}());

var __extends$b = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Composant permettant la selection d'un fichier
 * Exemple d'utilisation :
 * <asi-file-chooser (onValueChanged)="fileSelected($event)" formControlName="logo" (onError)="imageError($event)"></asi-file-chooser>
 */
var AsiFileChooserComponent = (function (_super) {
    __extends$b(AsiFileChooserComponent, _super);
    /**
     * @param {?} fileService
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiFileChooserComponent(fileService, elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.fileService = fileService;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.fileSrc = null;
        _this.fileName = null;
        _this.acceptAttribute = "";
        _this.icon = "fa-paperclip";
        _this.onError = new EventEmitter();
        _this.dragging = false;
        _this.loaded = false;
        _this.fileLoaded = false;
        return _this;
    }
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        if (this.fileSrc != null) {
            this.fileService.getFileAsBlob(this.fileSrc).subscribe(function (blob) {
                var /** @type {?} */ fileName = _this.fileSrc.split('/').pop();
                var /** @type {?} */ file = new Blob([blob], { type: blob.type });
                file.name = fileName;
                _this.value = blob;
            });
        }
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.ngOnChanges = function () {
        var _this = this;
        if (isArray(this.accept)) {
            this.accept.forEach(function (accept) {
                _this.acceptAttribute += accept.extension + ", " + accept.mimeType + ",";
            });
        }
        else if (this.accept != null) {
            var /** @type {?} */ accepts = this.accept;
            this.acceptAttribute = accepts.extension + ", " + accepts.mimeType;
        }
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.openFileInput = function () {
        this.fileInput.nativeElement.click();
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.getFileUrl = function () {
        return this.fileService.getFileUrl(this.value);
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.clean = function () {
        this.value = null;
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.handleDragEnter = function () {
        this.dragging = true;
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.handleDragLeave = function () {
        this.dragging = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AsiFileChooserComponent.prototype.handleDrop = function (e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    };
    /**
     * @return {?}
     */
    AsiFileChooserComponent.prototype.handleFileLoad = function () {
        this.fileLoaded = true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AsiFileChooserComponent.prototype.handleInputChange = function (event) {
        var /** @type {?} */ file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];
        if (!this.isValideMimeType(file.type)) {
            this.onError.emit({
                error: "FORMAT",
                file: file
            });
            return;
        }
        this.loaded = false;
        if (this.fileName != null) {
            file.name = this.fileName;
        }
        this.value = file;
    };
    /**
     * @param {?} mimeType
     * @return {?}
     */
    AsiFileChooserComponent.prototype.isValideMimeType = function (mimeType) {
        if (this.accept == null) {
            return true;
        }
        for (var _i = 0, _a = this.accept; _i < _a.length; _i++) {
            var accept = _a[_i];
            if (accept.mimeType == mimeType) {
                return true;
            }
        }
        return false;
    };
    AsiFileChooserComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-file-chooser',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"asi-file-chooser-container\"> <label ondragover=\"return false;\" [class.loaded]=\"loaded\" (dragenter)=\"handleDragEnter()\" (dragleave)=\"handleDragLeave()\" (drop)=\"handleDrop($event)\"> <input #fileInput type=\"file\" [disabled]=\"disabled\" name=\"file\" [accept]=\"acceptAttribute\" (change)=\"handleInputChange($event)\"/> <asi-fa-icon class=\"asi-focus-error\" (onClick)=\"openFileInput()\" [icon]=\"icon\" size=\"2x\"></asi-fa-icon> </label> <div class=\"file-link\" *ngIf=\"value != null\"> <a [innerHTML]=\"value.name\" download [href]=\"getFileUrl()\" target=\"_empty\"></a> <asi-fa-icon (onClick)=\"clean()\" icon=\"fa-trash-o\" size=\"lg\"></asi-fa-icon> </div> </div>",
                    host: { 'class': 'asi-component asi-file-chooser' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiFileChooserComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiFileChooserComponent.ctorParameters = function () { return [
        { type: AsiFileService, },
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiFileChooserComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'fileSrc': [{ type: Input },],
        'fileName': [{ type: Input },],
        'accept': [{ type: Input },],
        'icon': [{ type: Input },],
        'onError': [{ type: Output },],
        'fileInput': [{ type: ViewChild, args: ["fileInput",] },],
    };
    return AsiFileChooserComponent;
}(DefaultControlValueAccessor));

var AsiMimeType = (function () {
    /**
     * @param {?} extension
     * @param {?} mimeType
     */
    function AsiMimeType(extension, mimeType) {
        this.extension = extension;
        this.mimeType = mimeType;
    }
    AsiMimeType.PDF = new AsiMimeType(".pdf", "application/pdf");
    AsiMimeType.DOC = new AsiMimeType(".doc", "	application/msword");
    AsiMimeType.DOCX = new AsiMimeType(".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document");
    return AsiMimeType;
}());

var AsiFileChooserModule = (function () {
    function AsiFileChooserModule() {
    }
    /**
     * @return {?}
     */
    AsiFileChooserModule.forRoot = function () {
        return {
            ngModule: AsiFileChooserModule,
            providers: [AsiFileService]
        };
    };
    AsiFileChooserModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiFileChooserComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiFaIconModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiFileChooserComponent],
                    entryComponents: [],
                    providers: [AsiFileService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiFileChooserModule.ctorParameters = function () { return []; };
    return AsiFileChooserModule;
}());

var __extends$c = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiInputNumberComponent = (function (_super) {
    __extends$c(AsiInputNumberComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiInputNumberComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = "top";
        _this.step = 1;
        _this.disableInput = false;
        _this.hiddeAction = false;
        _this.inputControl = new FormControl();
        _this.pattern = new RegExp("^-*[0-9]*$");
        return _this;
    }
    /**
     * @return {?}
     */
    AsiInputNumberComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    /**
     * @return {?}
     */
    AsiInputNumberComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.inputControl.valueChanges.subscribe(function (value) {
                if (value === "") {
                    value = null;
                }
                if (value != null && _this.pattern.test(value)) {
                    if (_this.max != null && value > _this.max) {
                        value = _this.max;
                    }
                    if (_this.min != null && value < _this.min) {
                        value = _this.min;
                    }
                    _this.value = Number(value);
                }
                else if (value == null) {
                    _this.value = Number(value);
                }
                _this.inputElm.nativeElement.value = _this._value;
            });
        });
    };
    /**
     * @return {?}
     */
    AsiInputNumberComponent.prototype.increase = function () {
        if (this.value == null) {
            this.value = 0;
        }
        else if (this.max == null || this.value < this.max) {
            this.value = this.value + this.step;
        }
    };
    /**
     * @return {?}
     */
    AsiInputNumberComponent.prototype.decrease = function () {
        if (this.value == null) {
            this.value = 0;
        }
        else if (this.min == null || this.value > this.min) {
            this.value = this.value - this.step;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiInputNumberComponent.prototype.writeValue = function (value) {
        if (value == null || this.pattern.test(value)) {
            this._value = value;
        }
        else {
            this.inputElm.nativeElement.value = "Incorrect value";
        }
    };
    AsiInputNumberComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-input-number',
                    template: "<label *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"number-select\"> <button *ngIf=\"!hiddeAction\" class=\"minus\" [disabled]=\"disabled\" type=\"button\" (click)=\"decrease()\">-</button> <input #input [attr.disabled]=\"disabled || disableInput ? '' : null\" type=\"text\" class=\"asi-focus-error\" [formControl]=\"inputControl\" /> <button *ngIf=\"!hiddeAction\" class=\"plus\" [disabled]=\"disabled\" type=\"button\" (click)=\"increase()\">+</button> </div>",
                    host: { 'class': 'asi-component asi-input-number' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiInputNumberComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiInputNumberComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiInputNumberComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'step': [{ type: Input },],
        'disableInput': [{ type: Input },],
        'hiddeAction': [{ type: Input },],
        'min': [{ type: Input },],
        'max': [{ type: Input },],
        'inputElm': [{ type: ViewChild, args: ["input",] },],
    };
    return AsiInputNumberComponent;
}(DefaultControlValueAccessor));

var AsiInputNumberModule = (function () {
    function AsiInputNumberModule() {
    }
    /**
     * @return {?}
     */
    AsiInputNumberModule.forRoot = function () {
        return {
            ngModule: AsiInputNumberModule,
            providers: []
        };
    };
    AsiInputNumberModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiInputNumberComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiInputNumberComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiInputNumberModule.ctorParameters = function () { return []; };
    return AsiInputNumberModule;
}());

var __extends$d = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiInputComponent = (function (_super) {
    __extends$d(AsiInputComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiInputComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.placeholder = "";
        _this.labelPosition = "top";
        _this.maxlength = -1;
        _this.number = false;
        _this.type = 'text';
        _this.inputControl = new FormControl();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiInputComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        if (this.number == true) {
            this.pattern = new RegExp("^-*[0-9,\.]*$");
        }
    };
    /**
     * @return {?}
     */
    AsiInputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.inputControl.valueChanges.subscribe(function (value) {
            if (value == "") {
                _this.value = null;
            }
            else if (_this.isValide(value)) {
                _this.value = value;
            }
            else if (_this.maxlength != -1 && value.length > _this.maxlength) {
                //si la taille n'est pas respectée on coupe
                _this.value = value.substr(0, _this.maxlength);
            }
            _this.inputElm.nativeElement.value = _this._value;
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiInputComponent.prototype.isValide = function (value) {
        return value == null || ((this.maxlength == -1 || value.length <= this.maxlength)
            && (this.pattern == null || this.pattern.test(value)));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiInputComponent.prototype.writeValue = function (value) {
        if (this.isValide(value)) {
            this.inputControl.setValue(value, { emitEvent: false });
        }
        else if (this.maxlength != -1 && value.length > this.maxlength) {
            //Length incorrect on truncate
            this.inputControl.setValue(truncate(value, { length: this.maxlength }), { emitEvent: false });
        }
        else {
            //Pattern incorrect
            this.inputElm.nativeElement.value = "Incorrect value";
        }
    };
    AsiInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-input',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <input #input [attr.type]=\"type\" [attr.disabled]=\"disabled ? '' : null\" class=\"asi-focus-error\" [placeholder]=\"placeholder\" [formControl]=\"inputControl\" />",
                    host: { 'class': 'asi-component asi-input' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiInputComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiInputComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiInputComponent.propDecorators = {
        'label': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'pattern': [{ type: Input },],
        'maxlength': [{ type: Input },],
        'number': [{ type: Input },],
        'type': [{ type: Input },],
        'inputElm': [{ type: ViewChild, args: ["input",] },],
    };
    return AsiInputComponent;
}(DefaultControlValueAccessor));

var AsiInputModule = (function () {
    function AsiInputModule() {
    }
    /**
     * @return {?}
     */
    AsiInputModule.forRoot = function () {
        return {
            ngModule: AsiInputModule,
            providers: []
        };
    };
    AsiInputModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiInputComponent],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiInputComponent],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiInputModule.ctorParameters = function () { return []; };
    return AsiInputModule;
}());

var __extends$e = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiIconInputComponent = (function (_super) {
    __extends$e(AsiIconInputComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiIconInputComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.placeholder = "";
        _this.labelPosition = "top";
        _this.iconPosition = 'left';
        _this.maxlength = -1;
        _this.number = false;
        _this.type = 'text';
        _this.inputControl = new FormControl();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiIconInputComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        this.renderer.addClass(this.inputPanelElm.nativeElement, "icon-" + this.iconPosition);
        if (this.number == true) {
            this.pattern = new RegExp("^-*[0-9,\.]*$");
        }
    };
    /**
     * @return {?}
     */
    AsiIconInputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.inputControl.valueChanges.subscribe(function (value) {
            if (value == "") {
                _this.value = null;
            }
            else if (_this.isValide(value)) {
                _this.value = value;
            }
            else if (_this.maxlength != -1 && value.length > _this.maxlength) {
                //si la taille n'est pas respectée on coupe
                _this.value = value.substr(0, _this.maxlength);
            }
            _this.inputElm.nativeElement.value = _this._value;
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiIconInputComponent.prototype.isValide = function (value) {
        return value == null || ((this.maxlength == -1 || value.length <= this.maxlength)
            && (this.pattern == null || this.pattern.test(value)));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiIconInputComponent.prototype.writeValue = function (value) {
        if (this.isValide(value)) {
            this.inputControl.setValue(value, { emitEvent: false });
        }
        else if (this.maxlength != -1 && value.length > this.maxlength) {
            //Length incorrect on truncate
            this.inputControl.setValue(truncate(value, { length: this.maxlength }), { emitEvent: false });
        }
        else {
            //Pattern incorrect
            this.inputElm.nativeElement.value = "Incorrect value";
        }
    };
    AsiIconInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-icon-input',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"input-panel\" #inputPanel> <div class=\"icon-container\"> <asi-fa-icon [disabled]=\"true\" [icon]=\"icon\"></asi-fa-icon> </div> <input #input [attr.type]=\"type\" [attr.disabled]=\"disabled ? '' : null\" class=\"asi-focus-error\" [placeholder]=\"placeholder\" [formControl]=\"inputControl\" /> </div>",
                    host: { 'class': 'asi-component asi-icon-input' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiIconInputComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiIconInputComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiIconInputComponent.propDecorators = {
        'label': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'icon': [{ type: Input },],
        'iconPosition': [{ type: Input },],
        'pattern': [{ type: Input },],
        'maxlength': [{ type: Input },],
        'number': [{ type: Input },],
        'type': [{ type: Input },],
        'inputElm': [{ type: ViewChild, args: ["input",] },],
        'inputPanelElm': [{ type: ViewChild, args: ["inputPanel",] },],
    };
    return AsiIconInputComponent;
}(DefaultControlValueAccessor));

var AsiIconInputModule = (function () {
    function AsiIconInputModule() {
    }
    /**
     * @return {?}
     */
    AsiIconInputModule.forRoot = function () {
        return {
            ngModule: AsiIconInputModule,
            providers: []
        };
    };
    AsiIconInputModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiIconInputComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiFaIconModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiIconInputComponent, AsiFaIconModule],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiIconInputModule.ctorParameters = function () { return []; };
    return AsiIconInputModule;
}());

/**
 * Directive permettant d'afficher une ligne de message d'erreur
 * cette directive est liée au composant  error-messages
 * error :  type de l'erreur de gerer (exemple : 'required')
 * value :  valeur du message à afficher interpreter par le translator
 */
var AsiMessage = (function () {
    function AsiMessage() {
    }
    AsiMessage.decorators = [
        { type: Directive, args: [{
                    selector: 'message, asi-message',
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiMessage.ctorParameters = function () { return []; };
    AsiMessage.propDecorators = {
        'error': [{ type: Input },],
        'value': [{ type: Input },],
        'onSubmit': [{ type: Input },],
    };
    return AsiMessage;
}());

/**
 * Composant de gestion des messages d'erreur sur un champ de formulaire
 * for : valeur du champ de validation a ecouter : exemple (loginForm.get('password').errors)
 *
 * Exemple d'utilisation :
 *
 *  <error-messages [for]="loginForm.get('password')">
 *        <message error="required" value="ERRORS.required"></message>
 *        <message error="minlength" value="ERRORS.minLength" [onSubmit]="true"></message>
 *  </error-messages>
 */
var AsiErrorMessages = (function () {
    /**
     * @param {?} element
     * @param {?} formGroupDirective
     */
    function AsiErrorMessages(element, formGroupDirective) {
        this.element = element;
        this.formGroupDirective = formGroupDirective;
        this.showOne = false;
        this.errorMessages = [];
        this.submitted = false;
    }
    /**
     * @return {?}
     */
    AsiErrorMessages.prototype.ngOnInit = function () {
        var _this = this;
        if (this.forName != null) {
            this.for = (this.formGroupDirective.control.controls[this.forName]);
        }
        this.forGroupeSub = this.formGroupDirective.ngSubmit.subscribe(function () {
            _this.submitted = true;
            _this.onStatusChange();
        });
        this.forSub = this.for.statusChanges.subscribe(function () {
            _this.submitted = false;
            _this.onStatusChange();
        });
    };
    /**
     * @return {?}
     */
    AsiErrorMessages.prototype.ngAfterContentInit = function () {
        if (this.isFieldRequired()) {
            this.element.nativeElement.parentElement.classList.add("asi-required");
        }
    };
    /**
     * @return {?}
     */
    AsiErrorMessages.prototype.isFieldRequired = function () {
        var /** @type {?} */ required = false;
        this.messages.forEach(function (element) {
            if (element.error == 'required') {
                required = true;
            }
        });
        return required;
    };
    /**
     * Methode appellée à chaque changement de l'entré du composant "for"
     * @return {?}
     */
    AsiErrorMessages.prototype.onStatusChange = function () {
        var _this = this;
        var /** @type {?} */ messagesError = [];
        if (this.for.touched || this.submitted) {
            if (this.for.errors != null && this.messages != null) {
                this.messages.forEach(function (message) {
                    if (_this.for.errors[message.error] != null && (!message.onSubmit || _this.submitted) && !(_this.showOne && messagesError.length > 0)) {
                        messagesError.push(message);
                    }
                });
            }
        }
        this.errorMessages = messagesError;
        if (this.errorMessages.length > 0) {
            this.element.nativeElement.parentElement.classList.add("asi-has-error");
            this.element.nativeElement.classList.add("active");
        }
        else {
            this.element.nativeElement.parentElement.classList.remove("asi-has-error");
            this.element.nativeElement.classList.remove("active");
        }
    };
    /**
     * @return {?}
     */
    AsiErrorMessages.prototype.ngOnDestroy = function () {
        this.element.nativeElement.parentElement.classList.remove("asi-has-error");
        this.element.nativeElement.parentElement.classList.remove("asi-required");
        this.element.nativeElement.classList.remove("active");
        this.forGroupeSub.unsubscribe();
        this.forSub.unsubscribe();
    };
    AsiErrorMessages.decorators = [
        { type: Component, args: [{
                    selector: 'error-messages , asi-error-messages',
                    template: "<div class=\"errorPanel\"> <ng-content select=\"message\"></ng-content> <div *ngFor=\"let message of errorMessages\" class=\"asi-error-message\">{{message.value | translate}}</div> </div>",
                    host: { 'class': 'asi-component asi-error-messages' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiErrorMessages.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: FormGroupDirective, decorators: [{ type: Inject, args: [forwardRef(function () { return FormGroupDirective; }),] },] },
    ]; };
    AsiErrorMessages.propDecorators = {
        'for': [{ type: Input },],
        'forName': [{ type: Input },],
        'showOne': [{ type: Input },],
        'messages': [{ type: ContentChildren, args: [AsiMessage,] },],
    };
    return AsiErrorMessages;
}());

var AsiErrorMessagesModule = (function () {
    function AsiErrorMessagesModule() {
    }
    /**
     * @return {?}
     */
    AsiErrorMessagesModule.forRoot = function () {
        return {
            ngModule: AsiErrorMessagesModule,
            providers: []
        };
    };
    AsiErrorMessagesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiMessage, AsiErrorMessages],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiMessage, AsiErrorMessages],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiErrorMessagesModule.ctorParameters = function () { return []; };
    return AsiErrorMessagesModule;
}());

var AsiTab = (function () {
    function AsiTab() {
    }
    AsiTab.decorators = [
        { type: Component, args: [{
                    selector: 'asi-tab',
                    template: '<ng-template><ng-content></ng-content></ng-template>',
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTab.ctorParameters = function () { return []; };
    AsiTab.propDecorators = {
        'label': [{ type: Input },],
        'contentTemplate': [{ type: ViewChild, args: [TemplateRef,] },],
        'headerTemplate': [{ type: ContentChild, args: ["header",] },],
    };
    return AsiTab;
}());

var AsiTabElement = (function () {
    function AsiTabElement() {
    }
    AsiTabElement.decorators = [
        { type: Component, args: [{
                    selector: 'asi-tab-element',
                    template: "<div class=\"tab-element\"> <ng-template [ngTemplateOutlet]=\"template\"></ng-template> </div>",
                    host: { 'class': 'asi-component asi-tab-element' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTabElement.ctorParameters = function () { return []; };
    AsiTabElement.propDecorators = {
        'template': [{ type: Input },],
        'index': [{ type: Input },],
    };
    return AsiTabElement;
}());

var AsiTabContent = (function () {
    function AsiTabContent() {
    }
    /**
     * @return {?}
     */
    AsiTabContent.prototype.getTabs = function () {
        return this.tabs;
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    AsiTabContent.prototype.showTab = function (tab) {
        if (this.currentTab != null) {
            this.currentTab.active = false;
        }
        this.currentTab = tab;
        this.currentTab.active = true;
    };
    /**
     * @return {?}
     */
    AsiTabContent.prototype.ngOnChanges = function () {
        this.showTab(this.tabs[0]);
    };
    AsiTabContent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-tab-content',
                    template: "<ng-container *ngIf=\"currentTab != null\"> <asi-tab-element [index]=\"currentTab.index\" [template]=\"currentTab.contentTemplate\"></asi-tab-element> </ng-container>",
                    host: { 'class': 'asi-component asi-tab-content' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTabContent.ctorParameters = function () { return []; };
    AsiTabContent.propDecorators = {
        'tabs': [{ type: Input },],
    };
    return AsiTabContent;
}());

var AsiTabGroup = (function () {
    function AsiTabGroup() {
        this.tabs = new Array();
    }
    /**
     * @param {?} tab
     * @return {?}
     */
    AsiTabGroup.prototype.showTab = function (tab) {
        this.asiTableContent.showTab(tab);
    };
    /**
     * @return {?}
     */
    AsiTabGroup.prototype.getTabs = function () {
        return this.tabs;
    };
    /**
     * @return {?}
     */
    AsiTabGroup.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.processTabs();
        this.subscription = this.queryTabs.changes.subscribe(function (_) { return _this.processTabs(); });
    };
    /**
     * @return {?}
     */
    AsiTabGroup.prototype.processTabs = function () {
        var _this = this;
        this.tabs = [];
        var /** @type {?} */ index = -1;
        this.queryTabs.forEach(function (tab) {
            tab.index = ++index;
            _this.tabs.push(tab);
        });
    };
    /**
     * @return {?}
     */
    AsiTabGroup.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    AsiTabGroup.decorators = [
        { type: Component, args: [{
                    selector: 'asi-tab-group',
                    template: "<div class=\"asi-tab-group\"> <div class=\"tab-header\"> <button type=\"button\" *ngFor=\"let tab of getTabs()\" (click)=\"showTab(tab)\" [translate]=\"tab.label\" [ngClass]=\"{ 'active' : tab.active}\"></button> </div> <div class=\"tab-content\"> <asi-tab-content [tabs]=\"getTabs()\"></asi-tab-content> </div> </div>",
                    host: { 'class': 'asi-component asi-tab-group' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTabGroup.ctorParameters = function () { return []; };
    AsiTabGroup.propDecorators = {
        'queryTabs': [{ type: ContentChildren, args: [AsiTab,] },],
        'asiTableContent': [{ type: ViewChild, args: [AsiTabContent,] },],
    };
    return AsiTabGroup;
}());

var AsiTabGroupModule = (function () {
    function AsiTabGroupModule() {
    }
    /**
     * @return {?}
     */
    AsiTabGroupModule.forRoot = function () {
        return {
            ngModule: AsiTabGroupModule,
            providers: []
        };
    };
    AsiTabGroupModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiTabGroup, AsiTab, AsiTabContent, AsiTabElement],
                    imports: [AsiNgToolsBaseModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiTabGroup, AsiTab],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiTabGroupModule.ctorParameters = function () { return []; };
    return AsiTabGroupModule;
}());

var AsiRadioElement = (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiRadioElement(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.value = false;
        this.onValueChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AsiRadioElement.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "asi-template-" + this.radio.templatePosition);
    };
    /**
     * @param {?} checked
     * @return {?}
     */
    AsiRadioElement.prototype.onRadioChecked = function (checked) {
        this.onValueChange.emit({ index: this.radio.index, value: checked });
    };
    AsiRadioElement.decorators = [
        { type: Component, args: [{
                    selector: 'asi-radio-element',
                    template: "  <div class=\"asi-radio-template\"><ng-template [ngTemplateOutlet]=\"radio.template\"></ng-template></div> <asi-checkbox type=\"radio\" [(ngModel)]=\"value\" (onValueChange)=\"onRadioChecked($event)\"></asi-checkbox>",
                    host: { 'class': 'asi-component asi-radio-element' },
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiRadioElement.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiRadioElement.propDecorators = {
        'radio': [{ type: Input },],
        'value': [{ type: Input },],
        'onValueChange': [{ type: Output },],
    };
    return AsiRadioElement;
}());

var AsiRadioComponent = (function () {
    function AsiRadioComponent() {
        this.templatePosition = 'right';
    }
    AsiRadioComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-radio',
                    template: '<ng-template><ng-content></ng-content></ng-template>'
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiRadioComponent.ctorParameters = function () { return []; };
    AsiRadioComponent.propDecorators = {
        'templatePosition': [{ type: Input },],
        'value': [{ type: Input },],
        'template': [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return AsiRadioComponent;
}());

var __extends$f = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiRadioGroupComponent = (function (_super) {
    __extends$f(AsiRadioGroupComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiRadioGroupComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.labelPosition = 'top';
        _this.vertical = false;
        _this.trackBy = null;
        _this.radios = new Array();
        return _this;
    }
    /**
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
        if (this.vertical) {
            this.renderer.addClass(this.elementRef.nativeElement, "asi-vertical");
        }
    };
    /**
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.getRadios = function () {
        return this.radios;
    };
    /**
     * @param {?} radioEvent
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.onRadioChecked = function (radioEvent) {
        var _this = this;
        this.radios.forEach(function (radio) {
            if (radio.index == radioEvent.index) {
                radio.active = true;
                _this.value = radio.value;
            }
            else {
                radio.active = false;
            }
        });
    };
    /**
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        var /** @type {?} */ index = -1;
        this.queryRadios.forEach(function (radio) {
            radio.index = ++index;
            _this.radios.push(radio);
        });
        this.initValue(this.value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.writeValue = function (value) {
        this._value = value;
        this.initValue(value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AsiRadioGroupComponent.prototype.initValue = function (value) {
        var _this = this;
        if (value == null) {
            this.radios.forEach(function (radio) {
                radio.active = false;
            });
        }
        else {
            if (this.trackBy != null) {
                this.radios.forEach(function (radio) {
                    radio.active = radio.value[_this.trackBy] == value[_this.trackBy];
                });
            }
            else {
                this.radios.forEach(function (radio) {
                    radio.active = (radio.value == value);
                });
            }
        }
    };
    AsiRadioGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-radio-group',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"asi-radio-container\"> <asi-radio-element *ngFor=\"let radio of getRadios()\"  [radio]=\"radio\"  [value]=\"radio.active\"  (onValueChange)=\"onRadioChecked($event)\"> </asi-radio-element> </div>",
                    host: { 'class': 'asi-component asi-radio-group' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiRadioGroupComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiRadioGroupComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiRadioGroupComponent.propDecorators = {
        'label': [{ type: Input },],
        'labelPosition': [{ type: Input },],
        'vertical': [{ type: Input },],
        'trackBy': [{ type: Input },],
        'queryRadios': [{ type: ContentChildren, args: [AsiRadioComponent,] },],
        'contentTemplate': [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return AsiRadioGroupComponent;
}(DefaultControlValueAccessor));

var AsiRadioGroupModule = (function () {
    function AsiRadioGroupModule() {
    }
    /**
     * @return {?}
     */
    AsiRadioGroupModule.forRoot = function () {
        return {
            ngModule: AsiRadioGroupModule,
            providers: []
        };
    };
    AsiRadioGroupModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiRadioComponent, AsiRadioGroupComponent, AsiRadioElement],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiCheckBoxModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiRadioComponent, AsiRadioGroupComponent, AsiRadioElement],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiRadioGroupModule.ctorParameters = function () { return []; };
    return AsiRadioGroupModule;
}());

/**
 * Custom from  validators
 */
var AsiValidators = (function () {
    function AsiValidators() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    AsiValidators.email = function (control) {
        return function (control) {
            if (control.value == null) {
                return null;
            }
            else {
                return Validators.email(control);
            }
        };
    };
    /**
     * @param {?} minDateControl
     * @return {?}
     */
    AsiValidators.minDateFromControl = function (minDateControl) {
        return function (control) {
            if (control.value != null && minDateControl.value != null
                && moment(control.value).isBefore(minDateControl.value, 'day')) {
                return {
                    minDate: { valid: false }
                };
            }
            else {
                return null;
            }
        };
    };
    /**
     * @param {?} maxDateControl
     * @return {?}
     */
    AsiValidators.maxDateFromControl = function (maxDateControl) {
        return function (control) {
            if (control.value != null && maxDateControl.value != null
                && moment(control.value).isAfter(maxDateControl.value, 'day')) {
                return {
                    maxDate: { valid: false }
                };
            }
            else {
                return null;
            }
        };
    };
    return AsiValidators;
}());

var AsiValidatorsModule = (function () {
    function AsiValidatorsModule() {
    }
    /**
     * @return {?}
     */
    AsiValidatorsModule.forRoot = function () {
        return {
            ngModule: AsiValidatorsModule,
            providers: []
        };
    };
    AsiValidatorsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiValidatorsModule.ctorParameters = function () { return []; };
    return AsiValidatorsModule;
}());

var __extends$g = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AsiIbanFRInputComponent = (function (_super) {
    __extends$g(AsiIbanFRInputComponent, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AsiIbanFRInputComponent(elementRef, renderer) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.placeholder = "";
        _this.labelPosition = "top";
        _this.countryControl = new FormControl();
        _this.countryControl.valueChanges.subscribe(function (value) {
            if (value == "") {
                console.log("value " + value);
            }
        });
        return _this;
    }
    /**
     * @return {?}
     */
    AsiIbanFRInputComponent.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "label-" + this.labelPosition);
    };
    AsiIbanFRInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'asi-ibanfr-input',
                    template: "<label class=\"input-label\" *ngIf=\"label != null\">{{label | translate}}</label> <div class=\"inputs-panel\"> <asi-input [placeholder]=\"'ASI-COMPONENT.ASI-IBAN.country' | translate\" [maxlength]=\"4\" [formControl]=\"countryControl\"></asi-input> <asi-input [placeholder]=\"'ASI-COMPONENT.ASI-IBAN.bank' | translate\" [number]=\"true\" [maxlength]=\"5\" [(ngModel)]=\"bank\"></asi-input> <asi-input [placeholder]=\"'ASI-COMPONENT.ASI-IBAN.branch' | translate\" [number]=\"true\" [maxlength]=\"5\" [(ngModel)]=\"branch\"></asi-input> <asi-input [placeholder]=\"'ASI-COMPONENT.ASI-IBAN.account' | translate\" [maxlength]=\"11\" [(ngModel)]=\"account\"></asi-input> <asi-input [placeholder]=\"'ASI-COMPONENT.ASI-IBAN.key' | translate\" [number]=\"true\" [maxlength]=\"2\" [(ngModel)]=\"key\"></asi-input> </div>",
                    host: { 'class': 'asi-component asi-ibanfr-input' },
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AsiIbanFRInputComponent; }),
                            multi: true
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiIbanFRInputComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AsiIbanFRInputComponent.propDecorators = {
        'label': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'labelPosition': [{ type: Input },],
    };
    return AsiIbanFRInputComponent;
}(DefaultControlValueAccessor));

var AsiIbanFRInputModule = (function () {
    function AsiIbanFRInputModule() {
    }
    /**
     * @return {?}
     */
    AsiIbanFRInputModule.forRoot = function () {
        return {
            ngModule: AsiIbanFRInputModule,
            providers: []
        };
    };
    AsiIbanFRInputModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AsiIbanFRInputComponent],
                    imports: [AsiNgToolsBaseModule.forRoot(), AsiInputModule.forRoot()],
                    exports: [AsiNgToolsBaseModule, AsiInputModule],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiIbanFRInputModule.ctorParameters = function () { return []; };
    return AsiIbanFRInputModule;
}());

var AsiNgToolsModule = (function () {
    function AsiNgToolsModule() {
    }
    /**
     * @return {?}
     */
    AsiNgToolsModule.forRoot = function () {
        return {
            ngModule: AsiNgToolsModule,
            providers: []
        };
    };
    AsiNgToolsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [AsiInputModule.forRoot(),
                        AsiRadioGroupModule.forRoot(),
                        AsiSelectModule.forRoot(),
                        AsiInputNumberModule.forRoot(),
                        AsiCheckBoxModule.forRoot(),
                        AsiTabGroupModule.forRoot(),
                        AsiFileChooserModule.forRoot(),
                        AsiImageChooserModule.forRoot(),
                        AsiErrorMessagesModule.forRoot(),
                        AsiDatePickerModule.forRoot(),
                        AsiCollapseModule.forRoot(),
                        AsiCodeViewerModule.forRoot(),
                        AsiBindHtmlModule.forRoot(),
                        AsiBindAndCompileHtmlModule.forRoot(),
                        AsiAutoCompleteMultipleModule.forRoot(),
                        AsiAutoCompleteModule.forRoot(),
                        AsiPaginationModule.forRoot(),
                        AsiSwitchModule.forRoot(),
                        AsiTableModule.forRoot(),
                        AsiTextareaModule.forRoot(),
                        AsiMenuModule.forRoot(),
                        AsiTinyMCEModule.forRoot(),
                        AsiDirectivesModule.forRoot(),
                        AsiFaIconModule.forRoot(),
                        AsiButtonModule.forRoot(),
                        AsiDmyPickerModule.forRoot(),
                        AsiPipesModule.forRoot(),
                        AsiServicesModule.forRoot(),
                        AsiDropdownModule.forRoot(),
                        AsiNotificationModule.forRoot(),
                        AsiDialogModule.forRoot(),
                        AsiIconInputModule.forRoot(),
                        AsiIbanFRInputModule.forRoot(),
                        AsiValidatorsModule.forRoot()],
                    exports: [AsiInputModule,
                        AsiRadioGroupModule,
                        AsiSelectModule,
                        AsiInputNumberModule,
                        AsiCheckBoxModule,
                        AsiTabGroupModule,
                        AsiFileChooserModule,
                        AsiImageChooserModule,
                        AsiErrorMessagesModule,
                        AsiDatePickerModule,
                        AsiCollapseModule,
                        AsiCodeViewerModule,
                        AsiBindHtmlModule,
                        AsiBindAndCompileHtmlModule,
                        AsiAutoCompleteMultipleModule,
                        AsiAutoCompleteModule,
                        AsiPaginationModule,
                        AsiSwitchModule,
                        AsiTableModule,
                        AsiTextareaModule,
                        AsiMenuModule,
                        AsiTinyMCEModule,
                        AsiDirectivesModule,
                        AsiFaIconModule,
                        AsiButtonModule,
                        AsiDmyPickerModule,
                        AsiPipesModule,
                        AsiServicesModule,
                        AsiNotificationModule,
                        AsiDropdownModule,
                        AsiDialogModule,
                        AsiIconInputModule,
                        AsiIbanFRInputModule,
                        AsiValidatorsModule],
                    entryComponents: [],
                    providers: []
                },] },
    ];
    /**
     * @nocollapse
     */
    AsiNgToolsModule.ctorParameters = function () { return []; };
    return AsiNgToolsModule;
}());

export { AsiNgToolsModule, AsiBindAndCompileHtmlModule, AsiNgToolsBaseModule, DefaultControlValueAccessor, AsiFileService, AsiBindAndCompileHtml, AsiButtonModule, AsiButtonComponent, AsiLinkButtonComponent, AsiDmyPickerModule, AsiSelectModule, AsiCheckBoxModule, AsiCheckboxComponent, AsiSelectComponent, AsiDmyPickerComponent, AsiTinyMCEModule, AsiTinyMCE, AsiMenuModule, AsiMenuItem, AsiMenu, AsiTextareaModule, AsiTextareaComponent, AsiTableModule, AsiPaginationModule, AsiPaginationComponent, AsiPaginationService, AsiTableData, AsiTableRequest, AsiTableSelectionModel, AsiTable, AsiTableInliner, AsiTableColumn, AsiSwitchModule, AsiSwitchComponent, AsiNotificationModule, AsiNotificationService, AsiNotification, AsiNotificationContainer, AsiNotificationConfig, AsiNotificationPosition, AsiNotificationType, AsiFaIconModule, AsiFaIconComponent, AsiAutoCompleteModule, AsiAutoCompleteComponent, AsiAutoCompleteMultipleModule, AsiAutoCompleteMultipleComponent, AsiBindHtmlModule, AsiBindHtml, AsiCodeViewerModule, AsiCodeViewer, AsiCollapseModule, AsiCollapseComponent, AsiCollapseHeader, AsiDatePickerModule, AsiCalendarModule, AsiDirectivesModule, MouseWheelDirective, NoDblclickPropagration, NoClickPropagration, FocusDirective, AsiCalendarComponent, AsiDatePickerComponent, AsiDialogModule, AsiDialogService, AsiDialog, AsiDialogContainer, AsiDialogConfig, AsiDialogView, AsiImageChooserModule, AsiImageChooserComponent, AsiFileChooserModule, AsiMimeType, AsiFileChooserComponent, AsiInputNumberModule, AsiInputNumberComponent, AsiInputModule, AsiInputComponent, AsiIconInputModule, AsiIconInputComponent, AsiErrorMessagesModule, AsiErrorMessages, AsiMessage, AsiTabGroupModule, AsiTab, AsiTabElement, AsiTabContent, AsiTabGroup, AsiRadioGroupModule, AsiRadioComponent, AsiRadioGroupComponent, AsiRadioElement, AsiDropdownModule, AsiDropdownService, AsiDropdownContainer, AsiDropDown, AsiIbanFRInputModule, AsiIbanFRInputComponent, AsiPipesModule, IntArrayPipe, AsiConcatPipe, AsiFilterPipe, AsiConcatTranslatePipe, AsiDatePipe, AsiValidatorsModule, AsiValidators, AsiServicesModule, AsiCookieService, AsiSessionStorageService, AsiCssInjectorService, AsiMomentService, AsiComponentService };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/@asi-ngtools/lib/index.js
// module id = ../../../../@asi-ngtools/lib/index.js
// module chunks = 3